const messages = {
  pt: {
    translations: {
      mutes: {
        menuMute: "Silenciar notificações…",
        menuUnmute: "Reativar som",
        title: "Silenciar notificações",
        d8h: "8 horas",
        d1w: "1 semana",
        always: "Sempre",
        hint: "As mensagens continuam chegando e contando como não lidas; só o som e os avisos param.",
        groupHint: "Menções ao número da conexão ainda avisam.",
        tooltipUntil: "Silenciada até {{date}}",
        tooltip: "Silenciada",
        confirm: "Silenciar",
        cancel: "Cancelar",
      },
      metaBusinessAssets: {
        transferTickets: "Transferir tickets",
        defaultFlow: "Fluxo padrão",
        connectionIdentity: "Identificação da conexão",
        "title": "Contas autorizadas na Meta",
        "description": "Informe o ID do portfólio e o token do usuário do sistema para consultar as contas pertencentes a essa empresa. A consulta não altera a conexão. Selecione a conta e o número e clique em Salvar para aplicar.",
        "load": "Consultar contas na Meta",
        "account": "Conta do WhatsApp Business",
        "phone": "Número autorizado",
        "emptyAccounts": "A Meta não retornou contas pertencentes a esse portfólio. Confira o ID e os ativos atribuídos ao usuário do sistema.",
        "emptyPhones": "Nenhum número acessível foi retornado para essa conta.",
        "selected": "Conta e número selecionados nos campos acima. Revise os dados e clique em Salvar para aplicar à conexão.",
        "credentialsTitle": "Credenciais da Meta Business API",
        "credentialsHelp": "Integração de servidor para servidor. Configure o token de usuário do sistema no Meta Business e conceda acesso aos ativos da empresa. Não há login do Facebook nesta tela.",
        "phoneIdHelp": "Identificação do número de telefone na Meta",
        "accountIdHelp": "ID da conta do WhatsApp Business (WABA)",
        "businessIdHelp": "ID do portfólio empresarial no Gerenciador de Negócios",
        "phoneHelp": "Número completo com código do país, somente dígitos",
        "tokenHelp": "Token do usuário do sistema. A consulta de contas exige business_management e as permissões do WhatsApp aplicáveis. O token permanece oculto na tela.",
        "errors": {
          "ERR_META_INVALID_TOKEN": "Token inválido ou expirado. Confira o token do usuário do sistema na Meta.",
          "ERR_META_INVALID_ID": "Informe um ID válido do portfólio empresarial.",
          "ERR_META_BUSINESS_ACCESS": "A Meta negou o acesso. Confira business_management, as permissões do WhatsApp e os ativos atribuídos ao usuário do sistema.",
          "ERR_META_ACCOUNT_NOT_IN_BUSINESS": "A conta selecionada não pertence ao portfólio informado.",
          "ERR_META_INVALID_RESPONSE": "A Meta retornou uma resposta incompleta. Tente novamente.",
          "ERR_META_TOO_MANY_ASSETS": "A consulta excedeu o limite de ativos. Procure o administrador.",
          "ERR_NO_PERMISSION": "Somente um administrador pode consultar os ativos da Meta.",
          "ERR_NO_WAPP_FOUND": "A conexão não está disponível nesta empresa.",
          "default": "Não foi possível consultar a Meta. Confira as credenciais e tente novamente."
        }
      },
      copilot: {
        button: "Sugerir resposta",
        loading: "Gerando...",
        tooltip: "Gerar um rascunho de resposta com IA (revise antes de enviar)",
        summarize: "Resumir atendimento",
        instructions: {
          title: "Como responder",
          default: "Padrão",
          shorter: "Mais curto",
          formal: "Mais formal",
          invoice: "Explicar fatura",
        },
        dialog: {
          title: "Resumo do atendimento",
          loading: "Gerando resumo com IA...",
          empty: "Não foi possível gerar um resumo para este atendimento.",
          hint: "Gerado por IA a partir da conversa e dos dados do ERP vinculados. Confira antes de usar.",
          save: "Salvar como nota",
          savedLabel: "Nota salva",
          copy: "Copiar",
          close: "Fechar",
        },
        toasts: {
          inserted: "Rascunho inserido — revise antes de enviar",
          empty: "A IA não retornou sugestão para esta conversa.",
          copied: "Resumo copiado",
          saved: "Resumo salvo como nota interna",
        },
        settings: {
          title: "Copiloto (IA)",
          enabled: "Habilitar copiloto",
          enabledHelper: "Sugestões de resposta e resumos no atendimento.",
          apiKey: "Chave OpenAI",
          apiKeyHelper: "Cole a chave e saia do campo para salvar.",
          apiKeyConfigured: "Chave configurada. Digite uma nova para substituir.",
          model: "Modelo",
          modelHelper: "gpt-4o-mini é o mais barato e rápido.",
          summarizeOnTransfer: "Resumir ao transferir",
          summarizeOnTransferHelper: "Gera uma nota com o resumo ao transferir o ticket.",
          saved: "Configuração atualizada.",
          keySaved: "Chave salva.",
          saveError: "Não foi possível salvar a configuração.",
        },
      },
      auditLogs: {
        title: "Auditoria",
        subtitle: "Quem fez o quê, quando e em qual empresa",
        filters: {
          company: "Empresa",
          entity: "Entidade",
          action: "Ação",
          actorEmail: "E-mail do usuário",
          dateFrom: "De",
          dateTo: "Até",
          all: "Todas",
          apply: "Filtrar",
          clear: "Limpar",
          refresh: "Atualizar",
        },
        table: {
          date: "Data/hora",
          actor: "Quem",
          company: "Empresa",
          action: "Ação",
          entity: "Entidade",
          route: "Rota",
          status: "Status",
          details: "Detalhes",
          actorCompany: "Empresa do usuário",
          changes: "Dados enviados (mascarados)",
          noChanges: "Sem corpo na requisição.",
        },
        pagination: { showing: "Exibindo", of: "de", prev: "Anterior", next: "Próxima" },
        empty: {
          title: "Nenhum registro encontrado",
          message: "Ajuste os filtros ou aguarde novas ações no sistema.",
        },
        actions: {
          create: "Criação",
          update: "Edição",
          delete: "Exclusão",
          login: "Login",
          logout: "Logout",
          other: "Outra",
        },
        entities: {
          company: "Empresa",
          plan: "Plano",
          user: "Usuário",
          queue: "Fila",
          whatsapp: "Conexão",
          setting: "Configuração",
          queueIntegration: "Integração",
          contact: "Contato",
          contactList: "Lista de contatos",
          quickMessage: "Resposta rápida",
          campaign: "Campanha",
          tag: "Tag",
          schedule: "Agendamento",
          announcement: "Informativo",
          invoice: "Fatura",
          subscription: "Assinatura",
          ticketNote: "Nota do atendimento",
          ticket: "Atendimento",
          session: "Sessão",
          isp: "ERP / ISP",
          other: "Outra",
        },
      },
      terms: {
        title: "Termos de uso",
        description: "Para continuar usando o sistema, o administrador da empresa precisa ler e aceitar os termos de uso.",
        readLink: "Ler os termos de uso",
        version: "Versão",
        accept: "Li e aceito os termos",
        accepted: "Termos de uso aceitos com sucesso.",
        adminMustAccept: "O administrador da empresa precisa aceitar os termos de uso.",
        acceptPrefix: "Li e aceito os",
        acceptLink: "termos de uso",
        mustAccept: "Você precisa aceitar os termos de uso para se cadastrar.",
      },
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          disabled:
            "Cadastro de usuários está desabilitado no momento. Por favor, tente novamente mais tarde.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          company: "Nome da Organização",
          phone: "Whatsapp (DDD + NÚMERO)",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      ticketInfo: {
        copyPhone: "Copiar telefone",
        quickMessages: "Respostas rápidas",
        phonecopied: "Telefone copiado para área de transferência!",
        noPhone: "Nenhum telefone disponível para copiar",
        copyError: "Erro ao copiar telefone",
      },
      login: {
        hero: {
          title: "Atendimento inteligente no WhatsApp para o seu negócio",
          subtitle: "Centralize conversas, automatize respostas e acompanhe sua equipe em um só lugar.",
          feature1: "WhatsApp oficial e não oficial",
          feature2: "IA e integrações",
          feature3: "Campanhas e cobranças",
        },
        title: "Login",
        welcome: "Bem-vindo de volta",
        loginInstruction: "Entre com seus dados para acessar sua conta",
        form: {
          email: "Email",
          password: "Senha",
          button: "Acessar",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
        },
        token: "Token",
      },
      dashboard: {
        queueFilter: "Fila",
        allQueues: "Todas as filas",
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "T.M. de Atendimento",
          averageWaitingTime: "T.M. de Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuario",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        licence: {
          available: "Disponível até",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
        },
      },
      reports: {
        title: "Relatório de Pesquisas Realizadas",

        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado",
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações",
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento",
        },
        exportExcel: {
          title: "Relatórios de Atendimentos",
          startDate: "Data inicial",
          endDate: "Data final",
          notInformed: "Não informado",
          columns: {
            id: "ID",
            connection: "Conexão",
            contact: "Contato",
            user: "Usuário",
            queue: "Fila",
            status: "Status",
            lastMessage: "Última Mensagem",
            openDate: "Data Abertura",
            openTime: "Hora Abertura",
            closeDate: "Data Fechamento",
            closeTime: "Hora Fechamento",
            supportTime: "Tempo de Atendimento",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados",
        },
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },
      contactImportWpModal: {
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importação",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos",
        },
      },
      metaSignup: {
        coexTitle: "Conectar número do app WhatsApp Business",
        coexReady: "Clique abaixo, entre com o Facebook e escolha o número que já usa no app WhatsApp Business. Depois confirme no celular. O app continua funcionando.",
        coexSync: {
          none: "Coexistência ativa: o número também segue no app do celular.",
          requested: "Pedimos à Meta os contatos e o histórico do app. Chegam em alguns minutos.",
          importing: "Importando o histórico do app… {{count}} mensagens até agora.",
          done: "Histórico do app importado ({{count}} mensagens).",
          declined: "O dono do número não autorizou compartilhar o histórico. Mensagens novas chegam normalmente.",
          failed: "A Meta não aceitou o pedido de contatos/histórico. Tente \"Sincronizar de novo\" (só nas primeiras 24 h)."
        },
        title: "Conectar WhatsApp pela Meta",
        waiting: "Aguardando a tela de Conexões…",
        loadingSdk: "Carregando a Meta…",
        ready: "Clique abaixo para entrar com o Facebook e escolher (ou criar) a conta WhatsApp Business e o número.",
        button: "Conectar com o Facebook",
        working: "Registrando o número no sistema…",
        done: "Conectado! Você já pode fechar esta janela.",
        cancelled: "Conexão cancelada. Você pode fechar esta janela e tentar de novo.",
        notEnabled: "A conexão automática não está disponível para a sua empresa. Fale com o suporte.",
        fb: "Conclua na janela da Meta…",
        errors: {
          ERR_META_COEX_ONLY: "Esta conexão não é de coexistência.",
          ERR_META_COEX_SYNC_EXPIRED: "A Meta só aceita o pedido de histórico nas 24 h seguintes à conexão.",
          sdk: "Não foi possível carregar a Meta. Desative bloqueadores de anúncio para este site e tente de novo.",
          onlyWaba: "A janela criou a conta WhatsApp Business, mas nenhum número foi adicionado. Clique de novo e cadastre um número.",
          noIds: "A Meta não devolveu os dados do número a tempo. Clique de novo.",
          ERR_META_SIGNUP_CODE: "A Meta não aceitou o código (ele vale 30 segundos). Tente de novo.",
          ERR_META_SIGNUP_SCOPE: "A conta escolhida não liberou o acesso ao WhatsApp. Refaça escolhendo a conta e marcando todas as permissões.",
          ERR_META_SIGNUP_PHONE: "O número escolhido não pertence à conta WhatsApp Business selecionada.",
          ERR_META_NUMBER_IN_USE: "Este número já está conectado em outra empresa.",
          ERR_META_SIGNUP_RATE_LIMIT: "Muitas tentativas. Aguarde 10 minutos.",
          ERR_META_SIGNUP_NOT_CONFIGURED: "O app Meta da plataforma ainda não está configurado.",
          ERR_NO_PERMISSION: "Só o administrador da empresa pode conectar números.",
          generic: "Não foi possível concluir. Tente de novo ou fale com o suporte."
        },
        status: {
          ok: "Número ativo na API oficial.",
          pin_required: "O número já tinha verificação em duas etapas. Informe o PIN de 6 dígitos para concluir.",
          not_registered: "Conexão criada, mas o webhook/registro falhou. Use \"Conectar pela Meta\" de novo com o mesmo número.",
          review_pending: "Conexão criada. A conta ainda está em análise na Meta; o envio fica limitado até a aprovação."
        }
      },
      connections: {
        webchat: {
          menu: "Webchat (página de atendimento no navegador)",
          copyLink: "Copiar link",
          openPage: "Abrir página",
          linkCopied: "Link copiado",
          active: "Página no ar",
          inactive: "Página desligada",
        },
        metaSignup: {
          coexMenu: "Número do app WhatsApp Business (coexistência)",
          chip: { pin_required: "PIN pendente", not_registered: "Registro pendente", review_pending: "Em análise na Meta", coexistence: "Coexistência" },
          menu: "Conectar pela Meta (automático)",
          manual: "WhatsApp Oficial (cadastro manual)",
          popupBlocked: "O navegador bloqueou a janela. Libere pop-ups para este site e tente de novo.",
          done: "Número conectado pela Meta!",
          pinRequired: "Conexão criada. Informe o PIN de duas etapas na tela da conexão."
        },
        title: "Conexões",
        waitConnection: "Aguarde... Suas conexões serão reiniciadas!",
        newConnection: "Nova Conexão",
        restartConnections: "Reiniciar Conexões",
        callSupport: "Chamar Suporte",
        newConnection: "Nova Conexão",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        client: "Cliente",
        connectedConnections: " Conexões conectadas ",
        disconnectedConnections: "Conexões desconectadas ",
        totalConnections: " Total de Conexões",
        total: "Total",
        connections: "Conexões de:",

        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported:
            "Estamos fechando os tickets importados, por favor aguarde uns instantes",
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage:
            "Se você confirmar todos os tickets importados serão fechados",
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importação",
          importing: "Importando Mensagens do WhatsApp",
          newQr: "Novo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          number: "Número do Whatsapp",
          color: "Cor",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
          clientClosed: "Cliente fechou o ticket",
        },
      },
      whatsappModal: {
        webchat: {
          tab: "Página",
          section: "Página do webchat",
          title: "Título da página",
          titleHelp: "Aparece no topo da página. Vazio = nome da conexão.",
          welcomeText: "Texto de boas-vindas",
          welcomeHelp: "Mostrado antes de o cliente começar (até 500 caracteres).",
          requirePhone: "Pedir o WhatsApp do cliente",
          link: "Link para enviar aos clientes",
          linkPending: "O link aparece depois de salvar.",
          subtitle: " · Webchat",
          closingSection: "Mensagem de encerramento",
        },
        metaSignup: {
          coexTitle: "Coexistência com o app WhatsApp Business",
          coexHint: "O número segue no celular. O que você responder pelo app aparece aqui no atendimento; o bot não responde por cima dessas mensagens.",
          coexResync: "Sincronizar de novo",
          title: "Conectado pela Meta",
          review: "Análise da conta",
          quality: "Qualidade",
          sendPin: "Enviar PIN",
          pinLabel: "PIN (6 dígitos)",
          reconnectHint: "Para renovar o acesso, use Nova Conexão → Conectar pela Meta e escolha o mesmo número."
        },
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "Integrações",
          schedules: "Horário de expediente",
        },
        form: {
          importOldMessagesEnable: "Importar mensagens do aparelho",
          importOldMessages: "Data de inicio da importação",
          importRecentMessages: "Data de termino da importação",
          importOldMessagesGroups: "Importar mensagens de grupo",
          closedTicketsPostImported: "Encerrar tickets após importação",
          name: "Nome",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          default: "Padrão",
          group: "Permitir grupos",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          importAlert:
            "ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          maxUseInactiveTime: "Enviar flow de inatividade x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          timeToReturnQueue: "Tempo para retornar a fila em minutos",
          timeAwaitActiveFlow: "Tempo para aguardar ativação do fluxo",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          maxUseBotQueuesNPS:
            "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          lgpdLinkPrivacy: "Link para política de privacidade",
          lgpdMessage: "Mensagem de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmação do contato",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integração externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          flowInactiveTime:
            "Tempo em minutos para envio do flow de inatividade",
          whenExpiresTicket:
            "Encerrar chats abertos quando última mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          prompt: "Prompt",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          queueIdImportMessages: "Fila para importar as mensagens",
          isOficial: "Oficial",
          phone_number_id: "ID Número de telefone",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do negócio",
          phone_number: "Número de telefone",
          triggerIntegrationOnClose: "Disparar Integração ao Encerrar Ticket",
          enableIntegration: "Habilitar Integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          minutes: "minutos",
        },
        success: "Conexão salvo com sucesso.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
        errorRatingMessage:
          "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        conversationFlows: " Fluxos de Conversa",
        addFlow: "Adicionar Fluxo",
        editFlow: "Editar Fluxo ",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
        },
        loading: "Carregando...",
        loadMore: "Carregar Mais",
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          email: "Email",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          wallet: "Carteira",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importToExcel: "Importar / Exportar do Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          webchatNumber: "Contato do webchat: o número é interno e não muda.",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
          assignWallet: "Carteira de Cliente",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
        walletLinked: "Contato vinculado à sua carteira com sucesso!",
        walletError: "Usuário não possui filas associadas",
        saveFirst: "Contato deve ser salvo primeiro",
      },
      wallets: {
        title: "Carteiras de Contatos",
        searchPlaceholder: "Buscar contatos...",
        filterByUser: "Filtrar por Usuário",
        allUsers: "Todos os usuários",
        contact: "Contato",
        user: "Usuário",
        queue: "Fila",
        phone: "Telefone",
        email: "Email",
        actions: "Ações",
        editWallet: "Editar Carteira",
        selectUser: "Selecionar Usuário",
        selectQueue: "Selecionar Fila",
        selectUserAndQueue: "Selecione um usuário e uma fila",
        cancel: "Cancelar",
        save: "Salvar",
        confirmDeleteTitle: "Confirmar Exclusão",
        confirmDeleteMessage:
          "Tem certeza que deseja remover este contato da carteira?",
        deleteSuccess: "Contato removido da carteira com sucesso!",
        updateSuccess: "Carteira atualizada com sucesso!",
        wallet: "Carteira",
      },
      sla: {
        kind: { firstResponse: "1ª resposta", resolution: "Resolução" },
        status: { ok: "No prazo", warning: "Atenção", breached: "Estourado" },
        toast: {
          breached: "SLA estourado ({{kind}}): {{contact}}",
          breachedWithQueue: "SLA estourado ({{kind}}): {{contact}} ({{queue}})",
          unknownContact: "contato",
        },
        dashboard: {
          title: "SLA",
          hint: "Cumprimento das metas de tempo no período e fila filtrados",
          pctFirst: "1ª resposta no prazo",
          pctResolution: "Resolução no prazo",
          avgFirstResponse: "TMR médio (1ª resposta)",
          avgResolution: "Resolução média",
          total: "{{count}} atendimentos com SLA",
        },
      },
      aiLearning: {
        title: "Aprendizado da IA",
        subtitle: "Como os agentes de IA desta empresa melhoram com os atendimentos resolvidos",
        refresh: "Atualizar",
        settings: {
          title: "Configuração",
          enabled: "Aprendizado ligado",
          enabledHint: "A IA aprende com os atendimentos desta empresa — nunca com outras — e só muda o jeito de falar. Preços e regras não mudam.",
          approval: "Exigir minha aprovação para lições novas",
          approvalHint: "Lições novas ficam pendentes até você aprovar ou recusar aqui.",
          saved: "Configuração salva",
          noAgent: "Esta empresa ainda não tem agente de IA (integração de IA ou prompt). O aprendizado começa quando houver um.",
          cost: "Custo: as chamadas do aprendizado só aparecem em Uso de IA quando usam a chave da plataforma. Integração com chave própria é cobrada direto na conta OpenAI da empresa e não aparece aqui.",
        },
        lastRun: {
          title: "Última execução",
          never: "Ainda não rodou. A rotina roda de madrugada (04:00).",
          at: "{{date}}",
          summary: "{{evaluated}} atendimentos avaliados · {{created}} lições novas · {{reinforced}} reforçadas · {{discarded}} descartadas · {{memories}} memórias de cliente",
          discardedBy: "Descartadas por: {{list}}",
          cost: "Custo da rodada (chave da plataforma): {{value}}",
          skipped: "Não aprendeu nada: {{reason}}",
        },
        skipped: {
          disabled: "aprendizado desligado nesta empresa",
          no_agent: "a empresa não tem agente de IA",
          quota: "limite de uso de IA do plano atingido",
          volume: "poucos atendimentos bem-sucedidos (mínimo de 10)",
          no_key: "nenhuma chave da OpenAI disponível (nem própria nem da plataforma)",
          platform_off: "rotina desligada na plataforma",
          locked: "outra execução estava em andamento",
          extractionPrefix: "na extração de lições: {{reason}}",
        },
        discard: {
          pii: "dado pessoal",
          filter: "regra de segurança",
          regra: "regra de segurança",
          from_customer: "veio do cliente, não da equipe",
          judge: "reprovada na revisão",
          judge_injection: "lote com instrução suspeita",
        },
        cards: {
          successRate: "Sucesso nesta semana",
          pp: "{{value}} p.p.",
          vsLastWeek: "vs semana anterior",
          noData: "sem atendimentos",
          aiShare: "Conduzidos pela IA",
          aiShareHint: "só IA {{ai}} · mista {{mixed}}",
          evaluated: "Atendimentos avaliados",
          evaluatedHint: "nas últimas {{weeks}} semanas",
          activeLessons: "Lições ativas",
          pendingHint: "{{count}} aguardando aprovação",
        },
        chart: {
          title: "Taxa de sucesso por semana",
          hint: "Atendimentos encerrados com sucesso sobre o total da semana",
          tooltip: "Semana de {{week}}: {{success}} de {{total}} ({{rate}})",
          empty: "sem dados",
          week: "Semana",
          success: "Sucesso",
          total: "Total",
        },
        funnel: {
          title: "Funil de vendas",
          chegou: "Chegou",
          cotou: "Cotou",
          proposta: "Recebeu proposta",
          fechou: "Fechou",
        },
        stops: {
          title: "Onde os clientes param",
          hint: "Atendimentos sem sucesso, pelo momento em que o cliente parou",
          empty: "Nada registrado ainda.",
        },
        reasons: {
          title: "Motivos",
          empty: "Nada registrado ainda.",
          fatura_em_aberto: "fatura continua em aberto",
          reaberto_48h: "cliente voltou em até 48 h",
          sem_mensagem_cliente: "cliente não escreveu",
          sem_resposta_humana: "sem resposta da equipe",
        },
        lessons: {
          title: "Lições",
          hint: "O que a IA aprendeu e usa nas conversas. Desligue o que não fizer sentido.",
          text: "Lição",
          origin: "Origem",
          agent: "Agente",
          weight: "Peso",
          lastSeen: "Visto por último",
          status: "Situação",
          showExample: "Ver exemplo",
          hideExample: "Ocultar exemplo",
          approve: "Aprovar",
          reject: "Recusar",
          toggle: "Lição ligada",
          updated: "Lição atualizada",
          emptyTitle: "Ainda aprendendo",
          emptyMessage: "As primeiras lições aparecem depois da primeira noite com pelo menos 10 atendimentos bem-sucedidos.",
          filterEmpty: "Nenhuma lição nesta situação.",
          originLabels: {
            human: "Equipe",
            ai: "IA",
            mixed: "Equipe + IA",
          },
          agentLabels: {
            hospedagem: "Hospedagem",
            isp: "Suporte ISP",
            generic: "Prompt/IA",
            none: "—",
          },
          statusLabels: {
            all: "Todas",
            active: "Ativa",
            pending: "Pendente",
            disabled: "Desligada",
            expired: "Expirada",
          },
        },
      },
      ratings: {
        title: "Avaliações",
        subtitle: "Notas dadas pelos clientes ao fim do atendimento, por atendente",
        refresh: "Atualizar",
        cards: {
          total: "Avaliações",
          avg: "Média (0–10)",
          otimo: "% Ótimo",
          ruim: "% Ruim",
          responseRate: "Taxa de resposta",
        },
        filters: {
          dateFrom: "De",
          dateTo: "Até",
          attendant: "Atendente",
          allAttendants: "Todos",
          queue: "Fila",
          allQueues: "Todas",
          apply: "Filtrar",
        },
        labels: {
          otimo: "Ótimo",
          regular: "Regular",
          ruim: "Ruim",
        },
        attendants: {
          title: "Por atendente",
          hint: "Ordenado pela média no período",
          name: "Atendente",
          avg: "Média",
          count: "Avaliações",
          distribution: "Ótimo / Regular / Ruim",
          closedTickets: "Tickets fechados",
          responseRate: "% resposta",
          empty: "Nenhuma avaliação no período",
        },
        list: {
          title: "Avaliações recebidas",
          hint: "Mais recentes primeiro",
          date: "Data",
          contact: "Contato",
          attendant: "Atendente",
          queue: "Fila",
          rate: "Nota",
          ticket: "Ticket",
          showing: "Exibindo {{from}}–{{to}} de {{count}}",
          prev: "Anterior",
          next: "Próxima",
          emptyTitle: "Nenhuma avaliação encontrada",
          emptyMessage: "Ajuste o período ou os filtros. As avaliações aparecem quando o cliente responde à pergunta enviada ao fechar o atendimento.",
        },
      },
      supervision: {
        title: "Supervisão",
        subtitle: "Fila de espera, atendentes e SLA em tempo real",
        refresh: "Atualizar",
        updatedAt: "Atualizado {{time}}",
        cards: {
          waiting: "Aguardando",
          oldestWaiting: "Mais antigo aguardando",
          open: "Em atendimento",
          breached: "SLA estourado agora",
          online: "Atendentes online",
        },
        queues: {
          title: "Filas",
          hint: "Situação de cada fila agora e cumprimento do SLA hoje",
          queue: "Fila",
          waiting: "Aguardando",
          oldest: "Mais antigo",
          open: "Em atendimento",
          warning: "Aviso",
          breached: "Estourados",
          slaToday: "% no SLA hoje",
          noSla: "sem meta",
          emptyTitle: "Nenhuma fila com SLA configurado",
          emptyMessage: "Defina as metas de 1ª resposta e resolução em Filas & Chatbot → editar fila → seção SLA.",
          emptyAction: "Ir para Filas",
        },
        agents: {
          title: "Atendentes",
          hint: "Quem está online e a carga de cada um",
          online: "Online",
          offline: "Offline",
          lastSeen: "visto {{ago}}",
          openTickets: "Abertos",
          breached: "Estourados",
          avgFirstResponse: "TMR hoje",
          empty: "Nenhum atendente cadastrado",
        },
        time: {
          now: "agora",
          minutes: "há {{count}} min",
          hours: "há {{count}} h",
          days: "há {{count}} d",
          never: "nunca",
        },
        forbidden: "Você não tem permissão para acessar esta página",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        form: {
          slaTitle: "SLA (metas de tempo)",
          slaFirstResponse: "1ª resposta (min)",
          slaResolution: "Resolução (min)",
          slaWarning: "Aviso em (%)",
          slaHint: "Vazio = sem meta. O aviso (amarelo) aparece ao atingir a porcentagem da meta.",
          tipoIntegracao: "Tipo de Integração (ERP)",
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          typeRandomMode: "Tipo de rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "Integração",
          fileListId: "Lista de arquivos",
          closeTicket: "Fechar ticket",
          randomizeImmediate: "Randomizar Automaticamente (Imediato)",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
          addOptions: "Adicionar opções",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      erp: {
        integrationTypes: {
          NA: "Nenhuma",
          SB: "2ª via de boleto",
          AV: "A vencer",
          VE: "Vencidos",
          LC: "Liberação por confiança",
          ST: "Status da conexão",
        },
        sgpModes: {
          auto: "Automático (URA se App e Token preenchidos)",
          central: "Somente central do assinante",
          ura: "Somente API URA",
        },
        validation: {
          nameRequired: "Nome da integração é obrigatório.",
          sgpUrlRequired: "SGP URL é obrigatório.",
          sgpAppRequired: "Informe o App do SGP para usar o modo Somente API URA.",
          sgpTokenRequired: "Informe o Token do app do SGP para usar o modo Somente API URA.",
          sgpUraPairRequired: "Informe App e Token do app juntos para habilitar a API URA do SGP.",
          sgpModeInvalid: "Modo do SGP inválido.",
          ixcUrlRequired: "URL base do IXC é obrigatória.",
          ixcTokenRequired: "Token da API IXC é obrigatório.",
          asaasApiKeyRequired: "Chave de API do Asaas é obrigatória.",
          asaasEnvironmentInvalid: "Ambiente do Asaas inválido.",
          urlInvalid: "URL inválida. Use o formato https://...",
          timeoutInvalid: "Timeout deve ser um número maior que zero.",
          erpIntegrationRequired: "Selecione a integração ERP (SGP ou IXC).",
          openaiApiKeyRequired: "Chave da API OpenAI é obrigatória.",
          maxTurnsInvalid: "Máximo de turnos deve ser um número inteiro maior que zero.",
          hotspotBaseUrlRequired: "URL do Hotspot é obrigatória.",
          hotspotApiKeyRequired: "Chave de API do Hotspot é obrigatória.",
          hospedagemProviderRequired: "Selecione o provedor de hospedagem.",
          hospedagemBaseUrlRequired: "URL do site é obrigatória.",
          hospedagemApiKeyRequired: "Chave de API é obrigatória.",
          hospedagemIntegrationRequired: "Selecione o conector de hospedagem.",
          hospedagemNomeAgenteRequired: "Nome do agente é obrigatório.",
          hospedagemNomeEmpresaRequired: "Nome da empresa é obrigatório.",
          hospedagemPersonaRequired: "Persona do agente é obrigatória.",
        },
      },
      systemResources: {
        title: "Servidor",
        subtitle: "Uso de hardware da máquina onde o sistema roda",
        collectedAt: "Coletado às {{time}}",
        autoRefresh: "Atualizar a cada 15 s",
        refresh: "Atualizar",
        live: "ao vivo",
        loading: "Carregando…",
        error: "Não foi possível ler os recursos do servidor.",
        cpu: "CPU",
        cpuHint: "{{cores}} núcleos · carga {{load}}",
        memory: "Memória",
        disk: "Disco",
        uptime: "Servidor no ar há",
        processUptime: "backend há {{time}}",
        cpuSection: "Processador",
        cpuUsage: "Uso de CPU",
        cpuSample: "Média de todos os núcleos em 0,5 s",
        cpuModel: "Modelo",
        cores: "Núcleos",
        loadAvg: "Carga média (1 · 5 · 15 min)",
        memorySection: "Memória",
        ram: "RAM",
        swap: "Swap",
        memoryHint: "{{available}} disponíveis",
        total: "Total",
        used: "Em uso",
        available: "Disponível",
        disksSection: "Discos",
        diskHint: "{{used}} de {{size}} · {{free}} livres",
        noDisk: "Nenhum disco encontrado",
        processSection: "Processo e banco",
        node: "Node.js",
        processUptimeLabel: "Backend no ar há",
        rss: "Memória do backend (RSS)",
        heap: "Heap usado / total",
        database: "Banco de dados",
        databaseSize: "Tamanho do banco",
      },
      aiUsage: {
        title: "Uso de IA",
        used: "Usado no mês",
        credit: "Cota do plano",
        cap: "Teto",
        extra: "Crédito extra",
        kinds: { chat: "Conversa", transcription: "Transcrição de áudio", tts: "Resposta em voz" },
        noCredit: "Seu plano não inclui IA pela chave da plataforma.",
        onlyMeasuring: "Modo medição: o consumo é registrado mas nunca bloqueia.",
        byDay: "Consumo por dia",
        history: "Histórico",
        model: "Modelo",
        date: "Data",
        value: "Valor",
        noUsage: "Nenhum consumo registrado neste mês.",
        companyColumn: "IA (mês)",
        platform: {
          metaApp: {
            title: "App Meta (API oficial)",
            appId: "ID do app",
            configId: "Configuration ID (Embedded Signup)",
            secret: "Chave secreta do app",
            secretSet: "••••••• (gravada)",
            fromEnv: "do .env",
            save: "Salvar",
            saved: "App Meta salvo.",
            help: "Com os três valores, o botão \"Conectar pela Meta\" aparece em Conexões para as empresas cujo plano permite a API oficial."
          },
          title: "IA da plataforma",
          subtitle: "Chave compartilhada, tabela de preços e consumo por empresa",
          settings: "Configurações",
          key: "Chave OpenAI da plataforma",
          keySet: "Chave configurada",
          keyPlaceholder: "Cole a chave (não é exibida depois)",
          usdBrl: "Câmbio US$ → R$",
          multiplier: "Multiplicador de lucro",
          visionModel: "Modelo de visão (leitura de fotos/PDF)",
          visionModelHelp: "Padrão gpt-4o-mini. Usado pelo nó \"Ler arquivo\" do fluxo.",
          quotaMessage: "Mensagem ao cliente quando a cota acaba",
          prices: "Tabela de preços (US$)",
          model: "Modelo",
          inputPerMillion: "Entrada / 1M tokens",
          outputPerMillion: "Saída / 1M tokens",
          audioPerMinute: "Áudio / minuto",
          ttsPerMillionChars: "Voz / 1M caracteres",
          active: "Ativo",
          addModel: "Adicionar modelo",
          newModelPrompt: "Nome do modelo (ex.: gpt-4o-mini)",
          companies: "Consumo por empresa",
          company: "Empresa",
          period: "Período",
          used: "Usado",
          cost: "Custo",
          charged: "Cobrado",
          profit: "Lucro",
          credit: "Cota",
          cap: "Teto",
          enforce: "Bloquear ao bater o teto",
          enforceOn: "Bloqueia",
          enforceOff: "Só mede",
          extraCredit: "Liberar crédito extra",
          extraCreditPrompt: "Crédito extra (R$) para este mês:",
          extraCreditSaved: "Crédito extra liberado",
          enforceSaved: "Bloqueio atualizado",
          close: "Fechar mês",
          confirmClose: "Fechar o mês {{period}}? Os extratos serão gerados e o excedente entra na próxima fatura.",
          closed: "Mês fechado: {{n}} extratos, excedente R$ {{v}}",
          noCompanies: "Nenhuma empresa consumiu IA neste período.",
          saved: "Salvo",
          save: "Salvar"
        },
        companyKey: {
          title: "Chave OpenAI da empresa",
          set: "Configurada (…{{last4}})",
          usingPlatform: "Usando a chave da plataforma (consumo medido)",
          help: "Com uma chave própria, o consumo de IA da empresa não é medido nem cobrado pela plataforma. A chave nunca é exibida depois de salva.",
          field: "Chave OpenAI",
          placeholder: "sk-...",
          save: "Salvar",
          remove: "Remover",
          saved: "Chave da empresa salva",
          removed: "Chave removida — voltou a usar a da plataforma"
        },
        plan: { credit: "Crédito de IA/mês (R$)", multiplier: "Teto (× cota)" }
      },
      billingRules: {
        title: "Régua de cobrança",
        buttons: {
          new: "Nova regra",
          create: "Criar regra",
          save: "Salvar",
          cancel: "Cancelar",
          close: "Fechar",
          preview: "Prévia",
          runNow: "Executar agora",
          history: "Histórico",
          testSend: "Enviar teste para um número",
          edit: "Editar",
          delete: "Apagar",
        },
        stage: {
          beforeDays: "{{count}} dia antes",
          beforeDays_plural: "{{count}} dias antes",
          due: "No vencimento",
          afterDays: "{{count}} dia depois",
          afterDays_plural: "{{count}} dias depois",
        },
        table: {
          name: "Nome",
          stage: "Estágio",
          erp: "ERP",
          connection: "Conexão",
          template: "Template / texto",
          sendHour: "Hora",
          active: "Ativa",
          lastRun: "Última execução",
          actions: "Ações",
          metaTemplate: "Template Meta (WhatsApp oficial)",
          officialConnection: "WhatsApp oficial (Meta)",
          viewCampaign: "Ver campanha",
          sendPdf: "Anexa o PDF do boleto após a mensagem",
          copyButtons: "Botões de copiar (PIX / código de barras / abrir boleto)",
          copyButtonsShort: "Botões",
        },
        totals: {
          total: "Total",
          sent: "Enviadas",
          failed: "Falhas",
          pending: "Pendentes",
          skipped: "Puladas",
        },
        skippedReasons: {
          dedup: "Já enviada",
          optout: "Opt-out",
          noPhone: "Sem telefone",
          needsTemplate: "Sem template",
        },
        modal: {
          newTitle: "Nova regra de cobrança",
          editTitle: "Editar regra de cobrança",
        },
        form: {
          name: "Nome da regra",
          erpIntegration: "Integração ERP",
          whatsapp: "Conexão WhatsApp",
          official: "oficial",
          none: "Nenhum",
          stage: "Quando enviar",
          stageBefore: "Antes do vencimento",
          stageDue: "No dia do vencimento",
          stageAfter: "Depois do vencimento",
          offsetDays: "Dias",
          sendHour: "Hora de envio",
          metaTemplate: "Template aprovado",
          metaTemplateHelp: "Somente templates aprovados pela Meta podem ser usados nesta conexão.",
          loadingTemplates: "Carregando templates…",
          noApprovedTemplates: "Nenhum template aprovado para esta conexão. Crie e aprove um template em Templates WhatsApp.",
          goToTemplates: "Ir para Templates WhatsApp",
          variablesHelp: "Clique numa variável para inserir no texto:",
          textTemplate: "Texto da mensagem",
          replyQueue: "Fila para respostas do cliente",
          replyQueueHelp: "Quem responder a uma cobrança enviada há menos de 24 h cai direto nesta fila, sem passar pelo menu de setores.",
          defaultTemplate:
            "Olá {nome}! Sua fatura de {valor} vence em {vencimento}.\n\nLinha digitável: {linhaDigitavel}\nPIX copia e cola: {pix}\n\nSe já pagou, desconsidere esta mensagem.",
          active: "Regra ativa",
          activeHelp: "Regras ativas rodam automaticamente todos os dias na hora configurada.",
          sendPdf: "Anexar PDF do boleto (WhatsApp não oficial)",
          sendPdfHelp:
            "Depois do texto, o boleto em PDF é enviado como documento (SGP: link do boleto; IXC: arquivo do get_boleto). Se o PDF falhar, a mensagem de texto continua contando como enviada.",
          sendPdfOfficialHelp: "Disponível só em conexões não oficiais. O WhatsApp oficial (Meta) envia apenas o template aprovado.",
          copyButtons: "Botões de copiar (Copiar PIX · Copiar código de barras · Abrir boleto)",
          copyButtonsHelp:
            "O cliente recebe o texto sem os códigos longos e três botões nativos do WhatsApp: Copiar PIX, Copiar código de barras e Abrir boleto. Se o aparelho não aceitar botões, sai o texto completo com os códigos.",
          copyButtonsOfficialHelp:
            "No WhatsApp oficial a Meta não permite botão de copiar códigos longos (limite de 15 caracteres). Marque para preencher o botão de link \"Abrir boleto\" do template (URL dinâmica https://…/b/{{1}}); PIX e linha digitável vão no corpo do template.",
        },
        validation: {
          nameRequired: "Informe um nome com pelo menos 2 caracteres.",
          erpRequired: "Selecione a integração ERP.",
          whatsappRequired: "Selecione a conexão WhatsApp.",
          stageRequired: "Selecione o estágio.",
          offsetDaysInvalid: "Informe um número de dias entre 1 e {{max}}.",
          sendHourInvalid: "Hora inválida.",
          templateRequired: "Selecione um template aprovado.",
          textRequired: "Informe o texto da mensagem.",
          fixErrors: "Corrija os campos destacados.",
        },
        preview: {
          title: "Prévia da régua",
          loading: "Consultando faturas no ERP…",
          count: "Faturas que entrariam hoje",
          warnings: "Avisos",
          samples: "Exemplos de mensagens",
          noSamples: "Nenhuma fatura encontrada para este estágio hoje.",
          dueDate: "Vencimento",
          amount: "Valor",
        },
        runs: {
          title: "Histórico de execuções",
          empty: "Esta regra ainda não foi executada.",
          date: "Data",
          status: "Status",
          totals: "Totais",
          campaign: "Campanha",
          warnings: "Avisos da execução",
        },
        runStatus: {
          pending: "Pendente",
          running: "Em andamento",
          finished: "Concluída",
          failed: "Falhou",
          skipped: "Sem faturas",
          created: "Campanha criada",
          empty: "Sem faturas",
          error: "Erro",
        },
        confirm: {
          runTitle: "Executar agora a regra",
          runMessage: "Uma campanha de fatura será criada e as mensagens começarão a ser enviadas imediatamente. Deseja continuar?",
          forceTitle: "Executar de novo a regra",
          forceMessage: "Esta regra já foi executada hoje. Executar de novo mesmo assim? Uma nova campanha será criada (faturas já avisadas hoje são puladas).",
          deleteTitle: "Apagar a regra",
          deleteMessage: "A regra deixará de rodar. As campanhas já geradas por ela não serão apagadas.",
        },
        testSend: {
          title: "Enviar teste",
          help: "Pega a primeira fatura do estágio desta regra hoje e envia só para o número informado (texto, botões e PDF iguais ao envio real). Nada é gravado na régua.",
          number: "Número com DDD (ex.: 51999998888)",
          numberInvalid: "Informe DDD + número (10 a 13 dígitos).",
          send: "Enviar teste",
          sentTo: "Enviado para",
          invoiceOf: "Fatura usada",
          followUp: "Acompanhe o envio em Campanhas → Campanhas de fatura (campanha #{{id}}).",
        },
        toasts: {
          testSent: "Teste enviado para {{number}}. Acompanhe em Campanhas de fatura.",
          created: "Regra criada com sucesso.",
          updated: "Regra atualizada.",
          deleted: "Regra apagada.",
          activated: "Regra ativada.",
          deactivated: "Regra desativada.",
          runStarted: "Execução iniciada: {{total}} fatura(s) na campanha #{{campaignId}} ({{pending}} na fila, {{skipped}} pulada(s)).",
          runEmpty: "Nenhuma fatura entrou hoje ({{candidates}} candidata(s), {{skipped}} pulada(s)).",
        },
        empty: {
          noErpTitle: "Nenhuma integração ERP configurada",
          noErpText: "A régua de cobrança busca as faturas no seu ERP (SGP ou IXC). Configure uma integração em Filas & Chatbot → Integrações para começar.",
          noErpAction: "Ir para Integrações",
          noRulesTitle: "Monte sua régua de cobrança",
          noRulesText: "Cada regra envia automaticamente uma mensagem de WhatsApp para os clientes com fatura em um estágio: alguns dias antes do vencimento, no dia, ou depois de vencida. Exemplo de régua:",
          exampleBefore: "lembrete antes do vencimento",
          exampleDue: "aviso no dia",
          exampleAfter: "cobrança da fatura vencida",
        },
      },
      erpWriteback: {
        title: "Registro no ERP (anotações e O.S.)",
        enabled: "Registrar no ERP automaticamente",
        enabledHint: "Ao encerrar ou transferir um ticket, abre anotação ou O.S. no SGP/IXC conforme a regra da fila. Desligado, só o botão manual funciona.",
        rules: "Regras por fila",
        newRule: "Nova regra",
        editRule: "Editar regra",
        cancel: "Cancelar",
        save: "Salvar",
        edit: "Editar",
        remove: "Remover",
        extraInvalid: "Campos extras: JSON inválido",
        defaultRule: "Padrão (todas as filas)",
        queue: "Fila",
        integration: "Integração ERP",
        action: "O que abrir",
        actionNone: "Nada",
        actionNote: "Anotação",
        actionOs: "Ordem de serviço",
        trigger: "Quando",
        triggerClose: "Ao encerrar",
        triggerTransfer: "Ao transferir",
        triggerBoth: "Ao encerrar ou transferir",
        triggerManual: "Só manual (botão)",
        erpTypeId: "Tipo / assunto no ERP",
        erpTypeHint: "SGP: id do tipo de ocorrência. IXC: id_assunto.",
        erpSectorId: "Setor (IXC id_ticket_setor)",
        extraFields: "Campos extras (JSON)",
        extraHint: "Enviados como estão ao ERP. Ex.: {\"metodo\": \"WhatsApp\"}. Chaves app/token/senha são ignoradas.",
        includeLink: "Incluir link do ticket",
        active: "Ativa",
        supportWarn: "Este ERP não permite: {{what}}",
        log: "Últimos registros",
        logTicket: "Ticket",
        logAction: "Ação",
        logStatus: "Status",
        logErp: "ERP / nº",
        logWhen: "Quando",
        logError: "Erro",
        statusOk: "OK",
        statusError: "Erro",
        statusSkipped: "Pulado",
        saved: "Regra salva",
        deleted: "Regra removida",
        confirmDelete: "Remover esta regra?",
        noRules: "Nenhuma regra. Crie uma regra padrão ou por fila.",
        noLog: "Nenhum registro ainda."
      },
      networkAlerts: {
        index: {
          loading: "Consultando a base do ERP…",
          updatedAt: "Base do ERP atualizada em {{date}} · {{rows}} registros",
          running: "Indexando… página {{page}} ({{indexed}} registros)",
          never: "A base deste ERP ainda não foi indexada.",
          error: "Última indexação falhou: {{error}}",
          reindex: "Indexar agora",
          started: "Indexação iniciada; leva alguns minutos.",
          emptyTitle: "A base deste ERP ainda não foi indexada",
          emptyMessage: "A busca por área usa uma cópia local da base do SGP. Clique em Indexar agora e aguarde alguns minutos.",
          emptyMessageUser: "A busca por área usa uma cópia local da base do SGP. Peça a um administrador para indexar a base.",
        },
        title: "Problema Geral",
        subtitle: "Avise os clientes de uma área afetada e deixe o bot responder sozinho enquanto a falha durar.",
        activeBadge: "{{count}} em andamento",
        tabs: { search: "Buscar clientes", alerts: "Alertas" },
        buttons: {
          newAlert: "Novo alerta",
          search: "Buscar",
          createAlert: "Criar alerta para este escopo",
          broadcastNow: "Disparar aviso agora",
          edit: "Editar",
          close: "Encerrar",
          broadcast: "Disparar aviso",
          delete: "Apagar",
          cancel: "Cancelar",
          save: "Salvar",
          saveAndBroadcast: "Salvar e disparar",
          send: "Disparar",
          done: "Concluir",
          prev: "Anterior",
          next: "Próxima",
          viewCampaign: "Ver campanha",
          goToIntegrations: "Configurar integração ERP",
        },
        scope: {
          pon: "PON",
          olt: "OLT",
          nas: "Concentrador",
          city: "Cidade",
          region: "Região",
          all: "Todos os clientes",
          placeholder: {
            pon: "Ex.: 1/2/3",
            olt: "Ex.: OLT-CENTRO",
            nas: "Ex.: NAS-01 ou 10.0.0.1",
            city: "Ex.: Belo Horizonte",
            region: "Ex.: Zona Norte",
          },
        },
        groups: {
          label: "Grupo",
          placeholder: "Selecione ou digite para filtrar ({{total}})",
          loading: "Carregando grupos…",
          noOptions: "Nenhum grupo encontrado",
          noParent: "Sem OLT",
          clients: "{{count}} clientes",
          by: {
            label: "Agrupar por",
            olt: "OLT",
            pon: "PON",
            city: "Cidade",
            region: "Bairro",
          },
          idle: {
            title: "Selecione um grupo",
            message: "Escolha como agrupar (OLT, PON, cidade ou bairro) e selecione o grupo na lista. A busca acontece na hora.",
          },
          indexing: {
            title: "Indexando a base do ERP",
            message: "Os grupos ficam disponíveis assim que a indexação terminar. Isso leva alguns minutos.",
          },
        },
        search: {
          erp: "ERP",
          by: "Buscar por",
          value: "Valor",
          total: "cliente(s) encontrado(s)",
          page: "Página {{page}}",
          unsupported: "Este ERP não informa {{fields}}; busque por cidade ou região.",
          unsupportedBy: "Este ERP não permite busca por {{field}}; busque por cidade ou região.",
          idle: {
            title: "Encontre os clientes de uma área",
            message: "Escolha o tipo (PON, OLT, concentrador, cidade ou região), informe o valor e clique em Buscar.",
          },
          empty: {
            title: "Nenhum cliente encontrado",
            message: "Confira o valor digitado ou tente outro tipo de busca.",
          },
        },
        table: {
          name: "Cliente",
          contract: "Contrato",
          phones: "Telefone(s)",
          city: "Cidade / Bairro",
          olt: "OLT",
          pon: "PON",
          nas: "Concentrador",
        },
        filters: { active: "Ativos", closed: "Encerrados", all: "Todos" },
        card: {
          status: { active: "Em andamento", closed: "Encerrado" },
          startsAt: "Início",
          endsAt: "Previsão",
          hasPhoto: "Com foto",
          expired: "Expirado",
          noEnds: "Sem previsão",
          affected: "Clientes afetados",
          createdBy: "Criado por",
          erp: "ERP",
          campaign: "Campanha #{{id}}",
        },
        empty: {
          noErp: {
            title: "Nenhuma integração ERP configurada",
            message: "Cadastre uma integração SGP ou IXC em Filas & Chatbot → Integrações para buscar clientes por área.",
          },
          noAlerts: {
            title: "Nenhum alerta ativo",
            message: "Como funciona:",
            step1: "Busque os clientes da área afetada (PON, OLT, concentrador, cidade ou região).",
            step2: "Crie o alerta com um título curto e a mensagem que o bot vai enviar.",
            step3: "Opcional: dispare o aviso agora para todos os clientes do escopo.",
          },
          noAlertsFiltered: {
            title: "Nenhum alerta neste filtro",
            message: "Altere o filtro para ver alertas ativos ou encerrados.",
          },
        },
        form: {
          titleNew: "Novo alerta",
          titleEdit: "Editar alerta",
          subtitle: "Enquanto o alerta estiver ativo, o bot e a IA avisam os clientes do escopo automaticamente.",
          erp: "ERP",
          scopeType: "Escopo",
          scopeValue: "Valor do escopo",
          scopeAllHelp: "Todos os clientes desta integração serão avisados.",
          title: "Título curto",
          titlePlaceholder: "Ex.: Falha de energia na OLT Centro",
          message: "Mensagem para o cliente",
          messagePlaceholder: "Ex.: Nossa equipe já está no local trabalhando na normalização.",
          messageHelp: "Escreva como se estivesse falando com o cliente. Sem termos técnicos.",
          preview: "Como o bot vai enviar",
          startsAt: "Início",
          endsAt: "Válido até / previsão de normalização (horário de Brasília)",
          endsAtHelp: "Opcional. Hora de Brasília (UTC-3). Depois desse horário o aviso deixa de ser mostrado e entra como previsão na mensagem.",
          photoAttach: "Anexar foto",
          photoChange: "Trocar foto",
          photoRemove: "Remover foto",
          photoHelp: "Opcional: jpg, png ou webp até 5 MB. Vai junto do aviso no WhatsApp (imagem com o texto como legenda).",
          photoType: "Só imagens jpg, png ou webp.",
          photoSize: "Imagem maior que 5 MB.",
          active: "Alerta ativo",
        },
        preview: {
          withEnds: "⚠️ {{body}}. Previsão de normalização: {{endsAt}}",
          withoutEnds: "⚠️ {{body}}.",
          placeholder: "Preencha o título e a mensagem para ver a prévia.",
        },
        validation: {
          erpRequired: "Selecione a integração ERP.",
          scopeValueRequired: "Informe o valor do escopo.",
          titleRequired: "Informe um título.",
          messageRequired: "Informe a mensagem para o cliente.",
          endsBeforeStarts: "A previsão de normalização deve ser depois do início.",
        },
        confirm: {
          closeTitle: "Encerrar \"{{title}}\"?",
          closeMessage: "O bot deixa de avisar os clientes deste escopo. O alerta continua no histórico.",
          deleteTitle: "Apagar \"{{title}}\"?",
          deleteMessage: "Esta ação não pode ser desfeita. Campanhas já disparadas não são afetadas.",
        },
        broadcast: {
          title: "Disparar aviso",
          whatsapp: "Conexão",
          official: "Oficial",
          noConnections: "Nenhuma conexão WhatsApp disponível.",
          template: "Template aprovado",
          templateHelp: "Conexões oficiais só enviam templates aprovados pela Meta.",
          loadingTemplates: "Carregando templates…",
          noTemplates: "Nenhum template aprovado nesta conexão. Crie e aprove um template antes de disparar.",
          text: "Mensagem",
          textHelp: "Pré-preenchida com a mensagem do alerta. Você pode ajustar.",
          recipients: "Destinatários",
          recipientsUnknown: "todos do escopo",
          acknowledge: "Entendo que isso enviará {{count}} mensagens.",
          acknowledgeUnknown: "Entendo que isso enviará uma mensagem a cada cliente do escopo.",
          testNumber: "Enviar só para um número (teste)",
          testNumberHelp: "Preenchido: manda 1 mensagem só para este número, com o nome do primeiro cliente do escopo, sem marcar o alerta como disparado. Vazio: dispara para todos.",
          resultTitle: "Aviso na fila de envio",
          resultMessage: "Campanha #{{id}} criada com {{total}} mensagens. Acompanhe o progresso em Campanhas de fatura.",
        },
        toasts: {
          testSent: "Teste do aviso enviado para {{number}}.",
          created: "Alerta criado.",
          updated: "Alerta atualizado.",
          closed: "Alerta encerrado.",
          deleted: "Alerta apagado.",
          broadcastStarted: "Disparo iniciado: {{total}} mensagens na fila.",
        },
      },
      hotspot: {
        tabelas: {
          none: "—",
          varejo: "Varejo",
          atacado: "Atacado",
        },
        title: "Hotspot",
        subtitle: "Fichas, equipamentos e pagamentos do hotspot Wi-Fi.",
        tabs: {
          vouchers: "Fichas",
          devices: "Equipamentos",
          payments: "Pagamentos",
          summary: "Resumo",
        },
        comingSoon: "Em breve.",
        notConfigured: {
          title: "Hotspot não configurado",
          text: "Configure a integração Hotspot em Filas & Chatbot → Integrações para começar a gerar fichas.",
          action: "Configurar integração",
        },
        unavailable: {
          title: "Não foi possível carregar o Hotspot",
          text: "Ocorreu um erro ao consultar a integração. Tente novamente em instantes.",
          action: "Tentar de novo",
        },
        totals: {
          batches: "Lotes",
          vouchers: "Fichas",
          available: "Disponíveis",
          used: "Usadas",
          canceled: "Canceladas",
        },
        search: {
          placeholder: "Buscar por nome do lote…",
        },
        table: {
          name: "Nome",
          device: "Equipamento",
          duration: "Duração",
          quantity: "Quantidade",
          available: "Disp. / Usadas",
          status: "Status",
          createdAt: "Criado em",
          actions: "Ações",
          noDevice: "Sem equipamento",
          empty: "Nenhum lote encontrado.",
        },
        batchStatus: {
          liberado: "Liberado",
          aguardando_pagamento: "Aguardando pagamento",
        },
        buttons: {
          new: "Novo lote",
          viewVouchers: "Ver fichas",
          pdf: "PDF",
          copyPixLink: "Copiar link Pix",
          sendWhatsapp: "Enviar por WhatsApp",
          tryAgain: "Tentar de novo",
          close: "Fechar",
          cancel: "Cancelar",
          save: "Salvar",
          copy: "Copiar",
          send: "Enviar",
        },
        toasts: {
          linkCopied: "Link copiado.",
          pixCopied: "Código Pix copiado.",
          codeCopied: "Código copiado.",
          pdfError: "Não foi possível abrir o PDF.",
          batchCreated: "Lote criado com sucesso.",
          sent: "Enviado com sucesso.",
        },
        newBatch: {
          title: "Novo lote de fichas",
          name: "Nome do lote",
          namePlaceholder: "Ex.: Fichas do dia",
          quantity: "Quantidade",
          duration: "Duração",
          durationCustom: "Outra duração",
          durationCustomPlaceholder: "Valor",
          durationUnit: "Unidade",
          units: { min: "Minutos", h: "Horas", d: "Dias" },
          device: "Equipamento",
          deviceDefault: "Padrão da integração",
          priceLabel: "Rótulo do preço (opcional)",
          priceLabelPlaceholder: "Ex.: R$ 5,00 / 2h",
          wholesale: "Preço atacado (R$)",
          retail: "Preço varejo (R$)",
          generateCharge: "Gerar cobrança Pix",
          chargeRequired: "Obrigatório gerar a cobrança Pix para o seu perfil.",
          submit: "Criar lote",
          creating: "Criando…",
          quantityInvalid: "Informe uma quantidade entre 1 e 500.",
        },
        result: {
          title: "Lote criado",
          qrTitle: "QR Code Pix",
          pixCopyPaste: "Pix copia e cola",
          link: "Link de pagamento",
          done: "Concluir",
        },
        detail: {
          title: "Fichas do lote",
          code: "Código",
          status: "Status",
          usedAt: "Usado em",
          empty: "Nenhuma ficha encontrada.",
          loading: "Carregando fichas…",
        },
        sendDialog: {
          title: "Enviar por WhatsApp",
          help: "Informe o número que vai receber o lote (PDF ou link de pagamento).",
          number: "Número (com DDD)",
          numberInvalid: "Número inválido.",
          send: "Enviar",
        },
        send: {
          button: "Enviar fichas Wi-Fi",
          title: "Enviar fichas Wi-Fi",
          searchPlaceholder: "Buscar lote liberado…",
          createNow: "Criar lote agora",
          empty: "Nenhum lote liberado encontrado.",
          listTitle: "Selecione um lote liberado",
          change: "Trocar lote",
          toTicket: "As fichas serão enviadas para este atendimento.",
          numberLabel: "Número do cliente",
          numberInvalid: "Número inválido.",
          resultPdf: "Ficha enviada em PDF.",
          resultLink: "Link de pagamento enviado.",
        },
        duration: {
          minutes: "{{count}} min",
          minutes_plural: "{{count}} min",
          hours: "{{count}} h",
          hours_plural: "{{count}} h",
          days: "{{count}} dia",
          days_plural: "{{count}} dias",
        },
        errors: {
          notConfigured: "Hotspot não configurado.",
          unavailable: "Hotspot indisponível no momento.",
          noLink: "Nenhum link de pagamento disponível para este lote.",
        },
        devices: {
          table: {
            name: "Nome",
            slug: "Slug",
            status: "Status",
            lastContact: "Último contato",
            vpn: "VPN",
            modes: "Modos de acesso",
          },
          status: {
            online: "Online",
            offline: "Offline",
          },
          empty: "Nenhum equipamento encontrado.",
          refresh: "Atualizar",
        },
        payments: {
          filters: {
            status: "Status",
            device: "Equipamento",
            allStatuses: "Todos",
            allDevices: "Todos",
            from: "De",
            to: "Até",
          },
          status: {
            pago: "Pago",
            pendente: "Pendente",
            expirado: "Expirado",
          },
          table: {
            date: "Data",
            device: "Equipamento",
            description: "Descrição",
            value: "Valor",
            status: "Status",
            gateway: "Gateway",
            noDevice: "Sem equipamento",
            empty: "Nenhum pagamento encontrado.",
          },
        },
        summary: {
          cards: {
            online: "Online agora",
            leadsToday: "Leads hoje",
            leads7d: "Leads (7 dias)",
            leads30d: "Leads (30 dias)",
            paymentsPaid: "Pagamentos pagos",
            paymentsPending: "Pagamentos pendentes",
            paymentsExpired: "Pagamentos expirados",
            revenue: "Receita",
          },
          updatedAt: "Atualizado às {{time}}",
          empty: "Sem dados disponíveis.",
        },
      },
      metaTemplates: {
        "title": "Templates WhatsApp",
        "list": {
          "connection": "Conexão oficial",
          "search": "Buscar template…"
        },
        "buttons": {
          "sync": "Sincronizar com a Meta",
          "new": "Novo template",
          "edit": "Editar",
          "delete": "Apagar"
        },
        "table": {
          "name": "Nome",
          "category": "Categoria",
          "language": "Idioma",
          "status": "Status",
          "updatedAt": "Atualizado em",
          "actions": "Ações"
        },
        "empty": {
          "noConnectionTitle": "Nenhuma conexão WhatsApp Oficial",
          "noConnection": "Cadastre uma conexão WhatsApp Oficial em Conexões para criar e gerenciar templates aprovados pela Meta.",
          "goToConnections": "Ir para Conexões",
          "noTemplates": "Nenhum template ainda. Clique em \"Novo template\" ou em \"Sincronizar com a Meta\".",
          "noResults": "Nenhum template encontrado para essa busca."
        },
        "confirm": {
          "deleteTitle": "Apagar o template {{name}}?",
          "deleteMessage": "O template será removido da Meta e do sistema. Campanhas que o usam deixarão de funcionar."
        },
        "toasts": {
          "synced": "Sincronizado: {{total}} template(s) atualizado(s).",
          "deleted": "Template apagado.",
          "created": "Template enviado para análise da Meta.",
          "updated": "Edição enviada. O template voltou para análise da Meta.",
          "saveError": "Não foi possível salvar o template."
        },
        "status": {
          "APPROVED": "Aprovado",
          "PENDING": "Pendente",
          "REJECTED": "Rejeitado",
          "PAUSED": "Pausado",
          "noReason": "A Meta não informou o motivo."
        },
        "category": {
          "MARKETING": "Marketing",
          "UTILITY": "Utilidade",
          "AUTHENTICATION": "Autenticação"
        },
        "categoryHelp": {
          "MARKETING": "Promoções, ofertas e avisos gerais. Custo maior por conversa.",
          "UTILITY": "Cobranças, confirmações e atualizações de pedido/serviço. Indicado para fatura.",
          "AUTHENTICATION": "Códigos de verificação. A Meta define o texto; use só para OTP."
        },
        "language": {
          "pt_BR": "Português (Brasil)",
          "en_US": "Inglês (EUA)",
          "es": "Espanhol"
        },
        "parameterFormat": {
          "POSITIONAL": "Posicional",
          "NAMED": "Nomeada"
        },
        "headerFormat": {
          "NONE": "Nenhum",
          "TEXT": "Texto",
          "IMAGE": "Imagem",
          "DOCUMENT": "Documento",
          "VIDEO": "Vídeo"
        },
        "preview": {
          "business": "Sua empresa",
          "businessAccount": "Conta comercial",
          "empty": "A prévia da mensagem aparece aqui conforme você preenche o formulário.",
          "document": "documento.pdf",
          "copyCode": "Copiar código",
          "buttonPlaceholder": "Texto do botão",
          "seeAll": "Ver todas as opções"
        },
        "editor": {
          "titleNew": "Novo template",
          "titleEdit": "Editar template {{name}}",
          "close": "Fechar",
          "cancel": "Cancelar",
          "submit": "Enviar para análise",
          "saveEdit": "Salvar e reenviar",
          "metaError": "A Meta recusou o template:",
          "editNotice": "A Meta só aceita uma edição a cada 24 h; ao salvar, o template volta para análise. Nome e idioma não podem ser alterados.",
          "pendingNotice": "Este template ainda está em análise. A Meta não permite editar templates pendentes — aguarde a aprovação ou rejeição.",
          "previewTitle": "Prévia",
          "insertVariable": "Inserir variável",
          "variableName": "Nome da variável",
          "variableNameHelp": "Minúsculas, números e _ (ex.: nome, vencimento)",
          "insert": "Inserir",
          "billingVariables": "Variáveis sugeridas para cobrança (clique para inserir):",
          "examplesTitle": "Exemplo de cada variável (obrigatório para a Meta aprovar)",
          "format": {
            "bold": "Negrito",
            "italic": "Itálico",
            "strike": "Tachado"
          },
          "sections": {
            "basic": "Identificação",
            "basicHelp": "Nome único por conexão, categoria e idioma. A Meta usa a categoria para revisar e cobrar.",
            "header": "Cabeçalho (opcional)",
            "headerHelp": "Texto curto em negrito ou uma mídia no topo da mensagem.",
            "body": "Corpo",
            "bodyHelp": "Texto principal. Use variáveis para nome, valor, vencimento etc. e informe um exemplo para cada uma.",
            "footer": "Rodapé (opcional)",
            "footerHelp": "Linha curta em cinza no fim da mensagem.",
            "buttons": "Botões (opcional)",
            "buttonsHelp": "Até 10 botões: resposta rápida, link, telefone ou copiar código. Respostas rápidas devem ficar agrupadas."
          },
          "fields": {
            "whatsapp": "Conexão oficial",
            "name": "Nome do template",
            "nameHelp": "Convertido automaticamente para minúsculas com _ (ex.: cobranca_d3)",
            "nameLocked": "A Meta não permite renomear um template já enviado",
            "category": "Categoria",
            "language": "Idioma",
            "parameterFormat": "Formato das variáveis",
            "headerFormat": "Tipo de cabeçalho",
            "headerText": "Texto do cabeçalho",
            "headerTextHelp": "Até 60 caracteres, no máximo uma variável",
            "headerVarExample": "Exemplo para {{variable}} do cabeçalho",
            "headerMediaExample": "URL pública de exemplo",
            "headerMediaHelp": {
              "IMAGE": "Link público de uma imagem JPG/PNG (a Meta baixa para revisar).",
              "DOCUMENT": "Link público de um PDF de exemplo.",
              "VIDEO": "Link público de um vídeo MP4 de exemplo."
            },
            "body": "Texto da mensagem",
            "bodyPlaceholder": "Olá! Sua fatura vence em breve. Use o botão Inserir variável para personalizar.",
            "footer": "Texto do rodapé"
          },
          "buttons": {
            "count": "{{total}}/{{max}} botões",
            "add": "Adicionar botão",
            "empty": "Nenhum botão. Adicione respostas rápidas ou um link para pagar a fatura.",
            "type": {
              "QUICK_REPLY": "Resposta rápida",
              "URL": "Abrir link",
              "PHONE_NUMBER": "Ligar",
              "COPY_CODE": "Copiar código"
            },
            "moveUp": "Mover para cima",
            "moveDown": "Mover para baixo",
            "remove": "Remover",
            "text": "Texto do botão",
            "phone": "Telefone",
            "phoneHelp": "Com DDI, ex.: +5531999999999",
            "url": "URL",
            "urlHelp": "Pode terminar com uma variável para link dinâmico",
            "urlExample": "Exemplo de URL completa",
            "urlExampleHelp": "Obrigatório quando a URL tem variável",
            "copyCodeExample": "Código de exemplo",
            "copyCodeHelp": "Cupom ou código que o cliente copia"
          }
        },
        "validation": {
          "whatsappRequired": "Selecione a conexão WhatsApp Oficial.",
          "nameRequired": "Informe o nome do template.",
          "nameFormat": "O nome deve ter só letras minúsculas, números e _.",
          "categoryRequired": "Selecione a categoria.",
          "languageRequired": "Selecione o idioma.",
          "headerTextRequired": "Informe o texto do cabeçalho ou mude o tipo para Nenhum.",
          "headerTextTooLong": "O cabeçalho deve ter no máximo {{max}} caracteres.",
          "headerOneVariable": "O cabeçalho aceita no máximo uma variável.",
          "headerExampleRequired": "Informe um exemplo para a variável do cabeçalho.",
          "headerMediaExampleRequired": "Informe uma URL pública (http/https) de exemplo para a mídia do cabeçalho.",
          "bodyRequired": "Informe o texto da mensagem.",
          "bodyTooLong": "O corpo deve ter no máximo {{max}} caracteres.",
          "bodyExampleRequired": "Informe um exemplo para: {{vars}}.",
          "namedVariableFormat": "Nome de variável inválido ({{vars}}): use minúsculas, números e _, começando por letra.",
          "positionalSequence": "As variáveis posicionais devem ser numeradas em sequência a partir de 1, sem pular números.",
          "footerTooLong": "O rodapé deve ter no máximo {{max}} caracteres.",
          "tooManyButtons": "No máximo {{max}} botões.",
          "tooManyUrlButtons": "No máximo {{max}} botões de link.",
          "tooManyPhoneButtons": "Só é permitido um botão de telefone.",
          "tooManyCopyCodeButtons": "Só é permitido um botão de copiar código.",
          "buttonsGrouped": "Os botões de resposta rápida devem ficar agrupados (todos antes ou todos depois dos demais).",
          "buttonTextRequired": "Botão {{n}}: informe o texto.",
          "buttonTextTooLong": "Botão {{n}}: o texto deve ter no máximo {{max}} caracteres.",
          "buttonTextDuplicate": "Botão {{n}}: já existe um botão com esse texto.",
          "buttonUrlInvalid": "Botão {{n}}: informe uma URL válida começando com http:// ou https://.",
          "buttonUrlVariable": "Botão {{n}}: a URL só pode ter uma variável, e ela deve ficar no final.",
          "buttonUrlExampleRequired": "Botão {{n}}: informe um exemplo de URL completa.",
          "buttonPhoneInvalid": "Botão {{n}}: informe um telefone válido com DDI (ex.: +5531999999999).",
          "buttonCopyCodeRequired": "Botão {{n}}: informe o código de exemplo.",
          "buttonCopyCodeTooLong": "Botão {{n}}: o código deve ter no máximo {{max}} caracteres."
        }
      },
      invoiceCampaigns: {
        details: {
          of: "de",
          open: "Ver detalhes",
          searchPlaceholder: "Buscar por nome, número, contrato, fatura ou CPF",
          filters: {
            all: "Todas",
            sent: "Enviadas",
            failed: "Falhas",
            skipped: "Ignoradas",
            pending: "Pendentes",
          },
          columns: {
            customer: "Cliente",
            contract: "Contrato",
            invoice: "Fatura",
            dueDate: "Vencimento",
            amount: "Valor",
            number: "Número",
            otherNumbers: "Outros números",
            result: "Resultado",
            reason: "Motivo",
            sentAt: "Enviada em",
          },
          status: {
            sent: "Enviada",
            failed: "Falhou",
            pending: "Pendente",
            skipped_optout: "Ignorada",
            skipped_dedup: "Ignorada",
            skipped_needs_template: "Ignorada",
            skipped_no_phone: "Ignorada",
            skipped_cancelled: "Cancelada",
          },
          reason: {
            skipped_optout: "Cliente pediu para não receber",
            skipped_dedup: "Esta fatura já foi enviada recentemente",
            skipped_needs_template: "Canal oficial exige template aprovado",
            skipped_no_phone: "Sem telefone no ERP",
            skipped_cancelled: "Campanha cancelada antes do envio",
          },
          alsoTried: "Alternativa:",
          empty: "Nenhum envio encontrado.",
          export: "Exportar para Excel",
          exporting: "Exportando...",
          sheetName: "Envios",
          close: "Fechar",
        },
        filters: {
          overdue: "Vencidas",
          upcoming: "A vencer",
          alert: "Aviso de falha",
        },
        title: "Campanhas de Fatura",
        form: {
          name: "Nome da campanha",
          whatsapp: "Conexão WhatsApp",
          erpIntegration: "Integração ERP",
          filter: "Filtro de faturas",
          filterOverdue: "Vencidas",
          filterUpcoming: "A vencer",
          daysAhead: "Dias até o vencimento",
          template: "Mensagem (template)",
          variablesHelp: "Variáveis disponíveis (clique para inserir):",
          scheduledAt: "Agendar para (opcional)",
          scheduledAtHelp: "Deixe em branco para enviar imediatamente",
          metaTemplateName: "Nome do template Meta",
          metaTemplateNameHelp: "Obrigatório para conexões do WhatsApp oficial",
          none: "Nenhum",
          defaultTemplate: "Olá {nome}! Sua fatura do contrato {contrato} no valor de {valor} vence em {vencimento}.\nLinha digitável: {linhaDigitavel}\nPIX copia e cola: {pix}\nBoleto: {link}",
        },
        buttons: {
          preview: "Pré-visualizar",
          createAndSend: "Criar e enviar",
          cancel: "Cancelar campanha",
          close: "Fechar",
        },
        preview: {
          title: "Pré-visualização da campanha",
          total: "Total a enviar",
          optout: "Opt-out",
          dedup: "Já enviadas (7 dias)",
          needsTemplate: "Sem template Meta",
          samples: "Exemplos de mensagens",
          noSamples: "Nenhum exemplo retornado para os filtros escolhidos.",
        },
        table: {
          type: "Tipo",
          name: "Nome",
          status: "Status",
          pending: "Pendentes",
          sent: "Enviadas",
          failed: "Falhas",
          skipped: "Ignoradas",
          createdAt: "Criada em",
          actions: "Ações",
          empty: "Nenhuma campanha de fatura criada ainda.",
        },
        status: {
          pending: "Pendente",
          scheduled: "Agendada",
          running: "Em andamento",
          processing: "Em andamento",
          finished: "Finalizada",
          completed: "Finalizada",
          cancelled: "Cancelada",
          canceled: "Cancelada",
          failed: "Falhou",
        },
        validation: {
          nameRequired: "Informe o nome da campanha.",
          whatsappRequired: "Selecione a conexão WhatsApp.",
          erpRequired: "Selecione a integração ERP.",
          templateRequired: "Informe a mensagem da campanha.",
          daysAheadInvalid: "Dias até o vencimento deve ser um número inteiro maior ou igual a zero.",
          metaTemplateRequired: "Informe o nome do template Meta para conexões oficiais.",
        },
        toasts: {
          created: "Campanha de fatura criada com sucesso.",
          cancelled: "Campanha cancelada.",
        },
        confirmationModal: {
          cancelTitle: "Cancelar a campanha",
          cancelMessage: "Os envios pendentes serão interrompidos. Esta ação não pode ser desfeita.",
        },
      },
      queueIntegrationModal: {
        types: {
          SGP: "ERP SGP",
          IXC: "ERP IXC",
          ASAAS: "Asaas (cobrança)",
          ISP_IA: "IA de Suporte (ISP)",
          HOTSPOT: "Hotspot (Seu Hotspot)",
          HOSPEDAGEM_CONECTOR: "Conector de hospedagem (site)",
          HOSPEDAGEM_IA: "Agente Hospedagem",
        },
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          tipoIntegracao: "Tipo de integração",
          sgpIeSenha: "Usuário informa senha",
          sgpUrl: "SGP URL",
          sgpWidePayToken: "Widepay Token",
          sgpApp: "App (integração URA)",
          sgpToken: "Token do app",
          sgpTokenToggle: "Mostrar/ocultar token",
          sgpMode: "Modo",
          sgpModeHelp: "App + Token são cadastrados no SGP (Integrações → URA). Com eles o sistema consulta por CPF sem pedir a senha do assinante e habilita campanhas de fatura e a IA de suporte no SGP. Deixe em branco para usar só a central do assinante.",
          ixcUrl: "URL base do IXC",
          asaasApiKey: "Chave de API do Asaas",
          asaasEnvironment: "Ambiente do Asaas",
          asaasHelp: "Gere a chave em Asaas → Integrações → Chave de API. Use o Sandbox para testar. O Asaas cobre cliente, cobranças, boleto, linha digitável e PIX; não tem contrato de internet, desbloqueio nem status de conexão.",
          ixcToken: "Token da API IXC",
          timeoutMs: "Timeout (ms) — opcional",
          erpIntegrationId: "Integração ERP",
          openaiApiKey: "Chave da API OpenAI",
          model: "Modelo",
          handoffQueueId: "Fila para transferência (handoff)",
          receiptQueueId: "Fila para comprovantes (foto/PDF)",
          receiptQueueKeep: "Manter a fila atual",
          receiptQueueIdHelp: "Quando o cliente já identificado manda uma foto ou PDF durante o chatbot, o arquivo é lido pela IA como comprovante, conferido com as faturas em aberto e o ticket vai para esta fila com uma nota interna.",
          maxTurns: "Máximo de turnos",
          promptExtra: "Instruções extras do provedor",
          promptExtraHelp: "Texto adicionado ao prompt da IA (horários, políticas, tom de voz, etc.)",
          none: "Nenhum",
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
          hotspotBaseUrl: "URL do Hotspot",
          hotspotApiKey: "Chave de API",
          hotspotTest: "Testar conexão",
          hotspotDefaultDevice: "Equipamento padrão",
          hotspotDefaultTabela: "Tabela de preços padrão",
          hotspotHelp: "Gere a chave no painel do hotspot em Configurações → Integrações.",
          hospedagemProvider: "Provedor",
          hospedagemBaseUrl: "URL do site",
          hospedagemApiKey: "Chave de API",
          hospedagemTest: "Testar conexão",
          hospedagemPropostaHabilitada: "Site aceita proposta do agente (ligar só depois de publicar o site)",
          hospedagemPropostaHabilitadaHelp:
            "Desligado: o agente fecha por pré-reserva, como sempre. Ligue só depois que o site tiver a rota de propostas publicada; aí o agente passa a gerar o link da proposta, cotar no valor do cartão e seguir o roteiro de venda.",
          hospedagemIntegrationId: "Conector de hospedagem",
          openaiApiKeyOptionalHelp: "Vazio = usa a chave da plataforma.",
          nomeAgente: "Nome do agente",
          nomeEmpresa: "Nome da empresa",
          persona: "Persona do agente",
          personaHelp: "Instruções para o agente: quem ele é, tom de voz, regras — o texto que ele segue na conversa.",
          permitirPreReserva: "Permitir criar pré-reserva",
          pedirEmailParaReserva: "Pedir e-mail para reservar",
          voiceMode: "Resposta em áudio",
          voiceModeHelp: "Quando o agente responde por nota de voz",
          voiceModeMirror: "Quando o cliente mandar áudio (padrão)",
          voiceModeAlways: "Sempre que possível",
          voiceModeOff: "Nunca (só texto)",
          voice: "Voz (OpenAI TTS)",
        },
        hospedagem: {
          vendaTitle: "Venda e abertura",
          responderPrimeiraMensagem: "Responder à primeira mensagem do cliente",
          responderPrimeiraMensagemHelp: "Quando ligado, o agente responde direto ao que o cliente já escreveu (anúncio de origem, pergunta) em vez da abertura fixa. Se for só uma saudação, a abertura fixa continua.",
          fichaEmpresa: "Ficha da empresa",
          fichaEmpresaHelp: "Fatos fixos que a IA pode citar: endereço, regras da casa, horário de check-in e check-out, pets, estacionamento etc.",
          escadaTitle: "Escada de condições",
          escadaHelp: "Condições que a IA pode oferecer, uma de cada vez e nesta ordem, quando o cliente hesita no preço (até 4). Só é usada quando o site do conector aceita proposta; em alta temporada e feriados a IA não oferece condição especial.",
          escadaEmpty: "Nenhum degrau: a IA não oferece condição especial.",
          addDegrau: "Adicionar degrau",
          degrauN: "Degrau {{n}}",
          moveUp: "Subir",
          moveDown: "Descer",
          remove: "Remover",
          tipo: "Condição",
          tipoSelect: "Escolha a condição",
          tipos: {
            ISENTAR_LIMPEZA: "Isentar a limpeza",
            INCLUIR_EXTRA: "Incluir serviço extra",
            DESCONTO_PCT: "Desconto %",
            NOITE_EXTRA: "Noite extra com desconto",
          },
          pctDesconto: "Desconto (%)",
          pctNoite: "Desconto na noite extra (%)",
          pctHelp: "Número inteiro de 1 a {{max}}.",
          servicoExtraNome: "Serviço extra",
          servicoExtraNomeHelp: "Nome do serviço extra exatamente como está no site.",
          frase: "Como a IA apresenta",
          fraseHelp: "Frase que a IA usa para oferecer esta condição ao cliente.",
          periodosTitle: "Períodos sem escada (alta temporada)",
          periodosHelp: "Estadias com alguma noite nesses períodos não recebem condição especial.",
          periodosEmpty: "Nenhum período cadastrado.",
          addPeriodo: "Adicionar período",
          periodoN: "Período {{n}}",
          rotulo: "Nome do período",
          rotuloHelp: "Ex.: Réveillon, Férias de julho.",
          anual: "Repete todo ano",
          anualOnHelp: "Datas no formato DD/MM.",
          anualOffHelp: "Só nas datas escolhidas (com ano).",
          sim: "Sim",
          nao: "Não",
          inicio: "Início",
          fim: "Fim",
          incluirFeriadosNacionais: "Feriados nacionais e Carnaval também sem escada",
          incluirFeriadosHelp: "Bloqueia a escada no fim de semana prolongado de cada feriado nacional e no Carnaval.",
          errors: {
            fixFields: "Corrija os campos da escada de condições e dos períodos sem escada.",
            tipoRequired: "Escolha a condição.",
            maxDegraus: "Máximo de 4 degraus: remova este.",
            pctDesconto: "Informe um número inteiro de 1 a 10.",
            pctNoite: "Informe um número inteiro de 1 a 50.",
            extraRequired: "Informe o nome do serviço extra.",
            fraseRequired: "Escreva como a IA apresenta esta condição.",
            rotuloRequired: "Dê um nome ao período.",
            diaMesInvalid: "Data inválida (use DD/MM).",
            dataInvalid: "Data inválida.",
            fimAntesInicio: "O fim precisa ser igual ou depois do início.",
          },
        },
        buttons: {
          testErp: "Testar conexão",
          testErpSaveFirst: "Salve a integração primeiro para testar a conexão",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          erpHealthOk: "Conexão com o ERP OK",
          erpHealthFail: "Falha na conexão com o ERP",
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
          hotspotTestOk: "Conectado ao tenant {{name}}",
          hospedagemTestOk: "Conexão com o site OK",
        },
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Aberto",
          defaultMenuClosed: "Fechado",
          defaultMenu: "Menu padrão",
          defaultTheme: "Tema Padrão",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver fluxos",
          allowedWhatsapps: "Conexões que pode atender",
          allowedWhatsappsAll: "Todas",
          allowedWhatsappsHelp: "Nenhuma marcada = todas. Com conexões marcadas, o usuário só vê, abre e responde as conversas delas.",
        },
        tabs: {
          general: "Geral",
          permissions: "Permissões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuário salvo com sucesso.",
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          message: "Mensagem",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addSchedule: "Adicionar agendamento",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Tempo em minutos para redirecionar para lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensagem de saudação da lane",
          mediaFiles: "Mídia",
          rollbackLaneId: "Voltar para Lane após retomar atendimento",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Lane salva com sucesso.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensagem oculta",
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Fechados",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
          messageHidden: "Mensagem oculta",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Pendentes",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        status: {
          open: "Em atendimento",
          pending: "Aguardando",
          closed: "Finalizado",
          group: "Grupo",
        },
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
      },
      newTicketModal: {
        title: "Nova conversa",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        connectionRequired: "Selecione uma conexão",
        buttons: {
          ok: "Iniciar conversa",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          channelsGroup: "Canais e API",
          searchMenu: "Buscar menu…",
          phraseLists: "Listas de frases",
          flowbuilders: "Fluxos de conversa",
          platform: "Plataforma",
          configGroup: "Administração",
          automation: "Automação",
          billingGroup: "Cobrança & Provedor",
          attendance: "Atendimento",
          networkAlerts: "Problema Geral",
          hotspot: "Hotspot",
          aiPlatform: "IA da plataforma",
          systemResources: "Servidor",
          dashboard: "Dashboard",
          connections: "Canais de comunicação",
          chatsTempoReal: "Painel em tempo real",
          supervision: "Supervisão",
          ratings: "Avaliações",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          wallets: "Carteiras",
          queues: "Filas de atendimento",
          tags: "Tags",
          administration: "Administração",
          companies: "Empresas",
          users: "Equipe e usuários",
          birthdaySettings: "Aniversários",
          settings: "Preferências do sistema",
          files: "Arquivos",
          helps: "Ajuda",
          messagesAPI: "API e integrações",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          resellerFinance: "Financeiro da revenda",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Prompts de IA",
          aiLearning: "Aprendizado da IA",
          allConnections: "Gerenciar conexões",
          reports: "Relatórios",
          management: "Gestão",
          callHistorical: "Histórico de Chamadas",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token:
              "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
        messageHidden: "Mensagem oculta",
        newMessage: "Nova mensagem de",
      },
      triggerFlowModal: {
        title: "Disparar Fluxo",
        description:
          "Selecione um fluxo para executar neste ticket. O ticket será alterado para status 'chatbot' durante a execução.",
        selectFlow: "Escolha um fluxo",
        selectedFlow: "Fluxo selecionado",
        flowId: "ID do fluxo",
        noFlows: "Nenhum fluxo ativo encontrado",
        cancel: "Cancelar",
        trigger: "Disparar Fluxo",
        triggering: "Disparando...",
        success: "Fluxo disparado com sucesso!",
        error: "Erro ao disparar fluxo",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        selectMessage: "Selecionar Resposta Rápida",
        hasMedia: "Com mídia",
        global: "Global",
        noResultsFound: "Nenhuma resposta rápida encontrada para sua busca",
        noQuickMessages: "Nenhuma resposta rápida disponível",
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          general: "Geral",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },

      kanban: {
        title: "Kanban",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Painel",
          tags: "Lanes",
        },
      },

      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          invoiceCampaigns: "Campanhas de Fatura",
          metaTemplates: "Templates WhatsApp",
          billingRules: "Régua de cobrança",
          erpWriteback: "Registro no ERP",
          list: "Listagem",
          listContacts: "Lista de contatos",
          settings: "Configurações",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
      },
              campaignReport: {
          title: "Relatório de",
          inactive: "Inativa",
          scheduled: "Programada",
          process: "Em Andamento",
          cancelled: "Cancelada",
          finished: "Finalizada",
          campaign: "Campanha",
          validContacts: "Contatos Válidos",
          confirmationsRequested: "Confirmações Solicitadas",
          confirmations: "Confirmações",
          deliver: "Entregues",
          connection: "Conexão",
          contactLists: "Lista de Contatos",
          schedule: "Agendamento",
          conclusion: "Conclusão",
          fetchError: "Erro ao buscar dados do relatório",
          backButton: "Voltar",
        },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila exclu[ida com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      reports: {
        title: "Relatórios de Atendimentos",
        startDate: "Data Inicial",
        endDate: "Data final",
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Avaliados",
        },
        searchPlaceholder: "Pesquisar...",
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
      users: {
        title: "Usuários",
        table: {
          status: "Status",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      resellerFinance: {
        title: "Financeiro",
        subtitlePlatform: "Receita da plataforma: empresas e revendedores diretos",
        subtitleReseller: "Receita das suas empresas e a sua fatura com a plataforma",
        month: "Mês",
        stats: {
          receivable: "A receber",
          paid: "Recebido",
          overdue: "Em atraso",
          mrr: "MRR",
          mrrHint: "Soma dos planos das empresas ativas",
          payable: "Minha fatura",
          dueOn: "Vence em",
          noPayable: "Nenhuma fatura em aberto",
          invoices: "faturas",
          companies: "empresas",
          delinquentCompanies: "empresas inadimplentes",
          noOverdue: "Tudo em dia",
        },
        status: { open: "Em aberto", paid: "Paga", overdue: "Vencida", none: "Sem fatura" },
        delinquent: { title: "Inadimplentes", hint: "Faturas em aberto com vencimento passado" },
        byCompany: { title: "Por empresa" },
        byPlan: { title: "Por plano", hint: "Empresas ativas × valor do plano" },
        table: {
          company: "Empresa",
          plan: "Plano",
          value: "Valor",
          dueDate: "Vencimento",
          lastInvoice: "Última fatura",
          overdueDays: "Dias em atraso",
          days: "dias",
          actions: "Ações",
          companies: "Empresas",
          amount: "Valor",
          mrr: "MRR",
          inactive: "Inativa",
        },
        actions: { invoices: "Faturas", company: "Empresa" },
        empty: {
          title: "Nenhuma empresa ainda",
          message: "Cadastre empresas para acompanhar faturas, atrasos e MRR aqui.",
          action: "Cadastrar empresa",
        },
      },
      invite: {
        title: "Convite",
        loading: "Verificando convite...",
        invitedTo: "Você foi convidado para",
        instruction: "Defina sua senha para começar.",
        form: {
          email: "E-mail",
          name: "Seu nome",
          namePlaceholder: "Como quer ser chamado",
          password: "Senha",
          passwordHelper: "Mínimo de {{min}} caracteres",
          confirm: "Confirmar senha",
        },
        buttons: { submit: "Criar acesso e entrar" },
        alreadyHaveAccount: "Já tem acesso? Entrar",
        goToLogin: "Ir para o login",
        errors: {
          passwordMin: "A senha precisa ter pelo menos {{min}} caracteres.",
          passwordMismatch: "As senhas não conferem.",
        },
        toasts: { accepted: "Acesso criado! Bem-vindo." },
        notFound: { title: "Convite não encontrado", message: "Este link é inválido ou já foi utilizado. Peça um novo convite ao seu fornecedor." },
        expired: { title: "Convite expirado", message: "Este convite passou da validade. Peça um novo convite ao seu fornecedor." },
        generic: { title: "Não foi possível abrir o convite", message: "Tente novamente em instantes. Se persistir, peça um novo convite." },
      },
      onboarding: {
        title: "Primeiros passos",
        subtitle: "Complete estes itens para começar a atender.",
        hide: "Ocultar",
        progress: "concluídos",
        items: {
          connection: { title: "Conectar o WhatsApp", hint: "Leia o QR Code ou conecte a API oficial" },
          queue: { title: "Criar uma fila", hint: "Organize os atendimentos por setor" },
          team: { title: "Convidar a equipe", hint: "Adicione pelo menos mais um usuário" },
          quickMessage: { title: "Criar uma resposta rápida", hint: "Agilize respostas frequentes" },
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de arquivos",
          lastUpdate: "Ultimo update",
          actions: "Ações",
          money: "R$",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
          generateInvoice: "Gerar Fatura",
          type: "Tipo",
          typePlatform: "Plataforma",
          typeReseller: "Revendedor",
          typeCompany: "Empresa",
          domain: "Domínio",
          slug: "Subdomínio",
          slugHelper: "Letras minúsculas, números e hífen",
          slugRequired: "Revendedor precisa de um subdomínio",
          invalidSlug: "Subdomínio inválido ou reservado",
          customDomain: "Domínio próprio",
          customDomainHelper: "Ex.: painel.suaempresa.com.br (sem http/porta)",
          invalidCustomDomain: "Domínio próprio inválido",
          allowCustomBrand: "Marca própria",
          maxCompanies: "Limite de empresas",
          maxCompaniesHelper: "Vazio = sem limite",
          invalidMaxCompanies: "Limite de empresas inválido",
          openPanel: "Abrir painel",
          invoices: "Faturas",
          emptyTitle: "Nenhuma empresa ainda",
          emptyMessage: "As empresas que você cadastrar aparecem aqui.",
          dueDateHelper: "Sem data: 30 dias a partir de hoje",
          invite: "Convidar",
          inviteSent: "Convite gerado. Um e-mail foi enviado ao administrador da empresa.",
          inviteError: "Não foi possível gerar o convite.",
          inviteDialogTitle: "Convite de acesso",
          inviteDialogText: "Envie este link para o administrador de",
          inviteCopy: "Copiar link",
          inviteCopied: "Link copiado.",
          inviteCopyError: "Não foi possível copiar. Selecione o link e copie manualmente.",
          inviteExpires: "Válido até",
          inviteClose: "Fechar",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
          public: "Público",
          trial: "Trial",
          trialDays: "Dias Trial",
          platformPlan: "Plataforma",
          readOnly: "Plano da plataforma: somente leitura",
          perActiveCompanyAmount: "Valor por empresa ativa (R$)",
          perActiveCompanyAmountHelper: "Somado ao valor fixo, por empresa ativa do revendedor, na geração da fatura",
        },
      },
      helps: {
        title: "Central de Ajuda",
        settings: {
          codeVideo: "Código do Video",
          description: "Descrição",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
      },
      schedules: {
        title: "Agendamentos",
        date: "Data",
        time: "Hora",
        event: "Evento",
        allDay: "Dia Todo",
        week: "Semana",
        work_week: "Agendamentos",
        day: "Dia",
        month: "Mês",
        previous: "Anterior",
        next: "Próximo",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "Não há agendamentos no período.",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADICIONAR COLUNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluído com sucesso.",
        },
      },

      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em aberto",
        backToKanban: "VOLTAR PARA O KANBAN",

        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Lane?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lane",
        },
        toasts: {
          deleted: "Lane excluída com sucesso.",
        },
      },

      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          options: "Opções",
          plans: "Planos",
          helps: "Ajuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "Opções",
            schedules: "Horários",
            plans: "Planos",
            help: "Ajuda",
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            ratingButtons: "Avaliação por botões",
            ratingButtonsHelp: "Ao fechar o atendimento o cliente responde tocando em 👍 Ótimo / 😐 Regular / 👎 Ruim (WhatsApp não oficial). Nos demais canais continua por texto.",
            typingIndicator: "Mostrar \"digitando…\"",
            typingIndicatorHelp: "O cliente vê quando o atendente está digitando ou gravando áudio, e o atendente vê quando o cliente digita (WhatsApp não oficial).",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            copyContactPrefix: "Sigla para Cópia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage:
              "Mensagem de transferência - ${queue.name} = fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          dialogRatingTitle:
            "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Nenhuma mensagem selecionada",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            logTicket: "Logs do Ticket",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
            greetingAcceptedMessage:
              "Você deve configurar uma mensagem de saudação ao aceitar o ticket.",
          },
        },
      },
      conversation: {
        unread: "{{count}} mensagem não lida",
        unread_plural: "{{count}} mensagens não lidas",
        reactions: {
          react: "Reagir",
          more: "Mais emojis",
          you: "Você",
          clickToRemove: "clique para remover",
          unavailable: "Não foi possível enviar a reação.",
          unsupported: "Este canal não aceita reações.",
        },
        emojiPicker: {
          search: "Buscar emoji",
          notFound: "Nenhum emoji encontrado",
          results: "Resultados",
          recent: "Recentes",
          people: "Carinhas e pessoas",
          nature: "Animais e natureza",
          foods: "Comidas e bebidas",
          activity: "Atividades",
          places: "Viagens e lugares",
          objects: "Objetos",
          symbols: "Símbolos",
          flags: "Bandeiras",
        },
        sending: {
          sending: "Enviando…",
          failed: "Não enviada",
          retry: "Tentar de novo",
          discard: "Descartar",
          voice: "Mensagem de voz",
        },
        jump: {
          searching: "Procurando a mensagem…",
          loaded: "{{count}} carregada",
          loaded_plural: "{{count}} carregadas",
          cancel: "Parar a busca",
          notFound: "Essa mensagem não está nesta conversa.",
        },
        recorder: {
          label: "Gravação de áudio",
          time: "Tempo de gravação",
          discard: "Descartar gravação",
          pause: "Pausar gravação",
          resume: "Continuar gravação",
          send: "Enviar áudio",
        },
        gallery: {
          title: "Fotos e vídeos da conversa",
          counter: "{{current}} de {{total}}",
          previous: "Anterior",
          next: "Próxima",
          download: "Baixar",
          close: "Fechar",
          open: "Abrir mídia {{n}}",
          imageFailed: "Não foi possível carregar a imagem.",
          videoFailed: "Este vídeo não pode ser reproduzido no navegador.",
        },
        mentions: {
          participant: "participante",
          listLabel: "Participantes do grupo",
          noNumber: "Número não informado",
          admin: "Admin",
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderOpen:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras informações",
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
          scheduledDate: "Data do Agendamento",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios do contato?",
        appointmentsModal: {
          title: "Observações do Ticket",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferencia",
          triggerFlow: "Disparar Fluxo",
        },
        type: {
          imageVideo: "Fotos e vídeos",
          cam: "Câmera",
          contact: "Contato",
          meet: "Vídeo chamada",
          template: "Template Meta",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        talkTo: "Conversar Com",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Ação",
          of: "Faturas de",
          back: "Voltar",
        },
      },
      webchatVisitor: {
        title: "Cliente do webchat",
        phone: "WhatsApp informado",
        unconfirmed: "não confirmado",
        noPhone: "Não informou",
        since: "Primeira visita",
        lastSeen: "Visto por último",
        maybeSame: "Pode ser o mesmo cliente de:",
      },
      backendErrors: {
        ERR_WEBCHAT_OUTBOUND: "O webchat só responde a quem abriu a página; não dá para iniciar conversa por ele.",
        ERR_WEBCHAT_TRANSFER: "Tickets do webchat não podem ir para conexão de WhatsApp (e vice-versa).",
        ERR_WEBCHAT_UNSUPPORTED: "Isso não existe no webchat.",
        ERR_WEBCHAT_DISABLED: "A página de atendimento (webchat) está desligada: o cliente não veria a resposta. Ligue-a em Conexões para responder.",
        ERR_META_COEX_ONLY: "Esta conexão não é de coexistência.",
        ERR_META_COEX_SYNC_EXPIRED: "A Meta só aceita o pedido de histórico nas 24 h seguintes à conexão.",
        ERR_REACTION_INVALID_EMOJI: "Esse emoji não pode ser usado como reação.",
        ERR_REACTION_INVALID_TARGET: "Não dá para reagir a esta mensagem.",
        ERR_REACTION_TICKET_CLOSED: "O atendimento está encerrado: reabra para reagir.",
        ERR_REACTION_UNSUPPORTED_CHANNEL: "Este canal não aceita reações.",
        ERR_OFICIAL_MEDIA_TOO_LARGE: "Arquivo grande demais para a API oficial (imagem até 5 MB, áudio e vídeo até 16 MB, documento até 100 MB).",
        ERR_OFICIAL_MEDIA_UNSUPPORTED: "A API oficial do WhatsApp não aceita este tipo de arquivo.",
        ERR_INVALID_MENTIONS: "Não foi possível marcar os participantes. Escolha-os de novo na lista.",
        ERR_MENTIONS_LIMIT: "Muitas pessoas marcadas: o limite é 50 por mensagem.",
        ERR_ERP_CONTRACT_NOT_LINKED: "Este contrato não pertence ao cliente vinculado a este contato.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_TOO_MANY_LOGIN_ATTEMPTS: "Muitas tentativas de login. Aguarde 15 minutos e tente de novo.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_EDITING_WAPP_MSG: "Não foi possível editar a mensagem no WhatsApp.",
        ERR_EDIT_WINDOW_EXPIRED: "O WhatsApp só permite editar até 15 minutos depois do envio.",
        ERR_EDIT_NOT_SUPPORTED_CHANNEL: "Este canal não permite editar mensagens.",
        ERR_EDIT_NOT_OWN_MESSAGE: "Só é possível editar mensagens enviadas por você.",
        ERR_EDIT_EMPTY: "A mensagem não pode ficar vazia.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_ALLOWED_WHATSAPPS_INVALID: "Nenhuma das conexões marcadas existe mais. Desmarque e escolha de novo (ou deixe vazio para todas).",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
        ERR_DOMAIN_NOT_POINTING: "O domínio precisa apontar (CNAME) para app.{{baseDomain}} antes de ser salvo.",
        ERR_RESELLER_INACTIVE: "O revendedor responsável por esta conta está inativo. Entre em contato com o suporte.",
        ERR_RESELLER_LIMIT: "Limite de empresas do revendedor atingido.",
        ERR_PLAN_NOT_ALLOWED: "Este plano não está disponível para esta empresa.",
        ERR_TERMS_REQUIRED: "É necessário aceitar os termos de uso para se cadastrar.",
        ERR_TERMS_NOT_CONFIGURED: "Não há termos de uso configurados para esta empresa.",
        ERR_SLUG_IN_USE: "Este subdomínio já está em uso.",
        ERR_DOMAIN_IN_USE: "Este domínio já está em uso por outra empresa.",
        ERR_INVALID_SLUG: "Subdomínio inválido ou reservado. Use letras minúsculas, números e hífen.",
        ERR_INVALID_DOMAIN: "Domínio inválido. Informe só o host (ex.: painel.suaempresa.com.br), sem http ou porta.",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensagem"',
        fieldUserId: '"userId": ID do usuário ou ""',
        fieldQueueId: '"queueId": ID da Fila ou ""',
        fieldSendSignature: '"sendSignature": Assinar mensagem - true/false',
        fieldCloseTicket: '"closeTicket": Encerrar o ticket - true/false',
        singMessage: "Assinar mensagem - true/false",
        closeTicket: "Encerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      recurrenceSection: {
        title: "Recorrência",
        description:
          "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor do Intervalo",
        sendAsManyTimes: " Enviar quantas vezes",
        shipNormallyOnNonbusinessDays: " Enviar normalmente em dias não úteis",
        sendOneBusinessDayBefore: "Enviar um dia útil antes",
        sendOneBusinessDayLater: "Enviar um dia útil depois",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Painel de Atendimentos",
      },
      financial: {
        invoices: "Faturas",
        details: "Detalhes",
        users: "Usuários",
        connections: "Conexões",
        queues: "Filas",
        value: "Valor",
        expirationDate: "Data Venc.",
        status: "Status",
        action: "Ação",
      },
      statusFilter: {
        statusFilter: "Filtro por Status",
      },
      momentsUser: {
        services: "Atendimentos:",
        pending: "Pendentes",
        noqueue: "SEM FILA",
      },
      campaignsPhrase: {
        campaignsFlow: "Fluxo de Campanhas",
        campaigns: "Campanhas",
        name: "Nome",
        status: "Status",
        newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
        editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
        phraseTriggerName: "Nome do disparo por frase",
        chooseAStream: "Escolha um fluxo",
        whichPhraseTriggersTheFlow: " Qual frase dispara o fluxo?",
        selectAConnection: " Selecione uma Conexão",
        chooseAStream: " Escolha um fluxo",
        status: " Status",
        cancel: "CANCELAR",
        createCampaign: "CRIAR CAMPANHA ",
        saveCampaign: "Salvar Campanha",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Relatório do Atendimento",
          ticketId: "ID do Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Atendente",
          date: "Data",
          lastMessage: "Última Mensagem",
          fullReport: "O relatório completo foi anexado acima",
          resolveAndTriggerIntegration: "Resolver e Disparar Integração",
          elementNotFoundForExport: "Elemento não encontrado para exportar.",
          reportFilename: "relatório_atendimento",
        },
      },
      chatList: {
        noMessages: "Nenhuma mensagem",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Procurar chat...",
        createNewChat: "Criar novo chat",
        searchUser: "Procurar usuário...",
        noUserFound: "Nenhum usuário encontrado",
        noUserAvailable: "Nenhum usuário disponível",
        cancel: "Cancelar",
        details: "Detalhes",
        deleteChat: "Excluir Conversa",
        deleteChatConfirm: "Esta ação não pode ser revertida, confirmar?",
        detailsTitle: "Detalhes",
        edit: "Editar",
        delete: "Excluir",
        now: "agora",
        minutesAgo: "{{count}}m atrás",
        hoursAgo: "{{count}}h atrás",
      },
      chatMessages: {
        deleted: "Esta mensagem foi apagada",
        deletedAdmin: "Mensagem apagada - visível apenas para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        cancel: "Cancelar",
        deleteMessage: "Deletar Mensagem",
        deleteMessageConfirm: "Tem certeza que deseja deletar esta mensagem?",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        doubleClickToReply: "Clique duas vezes para responder",
        edited: "(editada)",
        forwarded: "(encaminhada)",
        typeMessage: "Digite uma mensagem...",
        send: "Enviar",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        replyingTo: "Respondendo a",
        clickToGoToOriginal: "Clique para ir até a mensagem original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Exclusão",
        confirm: "Confirmar",
        deleteMessage: "Tem certeza que deseja excluir esta mensagem?",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        forward: "Encaminhar",
        noChats: "Nenhum chat disponível",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Novo",
        messages: "Mensagens",
        search: "Buscar...",
        noChats: "Nenhum chat encontrado",
        noGroups: "Nenhum grupo encontrado",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        error: "Erro ao carregar dados",
        addGroupPhoto: "Adicionar Foto do Grupo",
        changeGroupPhoto: "Alterar Foto do Grupo",
        groupName: "Nome do Grupo",
        groupDescription: "Descrição do Grupo",
        save: "Salvar",
        cancel: "Cancelar",
        createGroup: "Criar Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Deletar Grupo",
        deleteGroupConfirm: "Tem certeza que deseja deletar este grupo?",
        edit: "Editar",
        delete: "Excluir",
        details: "Detalhes",
        groupDetails: "Detalhes do Grupo",
        title: "Título",
        description: "Descrição",
        modal: {
          title: "Criar grupo",
          name: "Nome do grupo",
          description: "Descrição do grupo",
          create: "Criar",
          cancel: "Cancelar",
          save: "Salvar",
          edit: "Editar",
        },
        modal: {
          title: "Criar Grupo",
          editTitle: "Editar Grupo",
          save: "Salvar",
          cancel: "Cancelar",
        },
      },
whitelabel: {
        primaryColorLight: "Cor Primária (Tema Claro)",
        primaryColorDark: "Cor Primária (Tema Escuro)",
        appName: "Nome da Aplicação",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Escuro)",
        favicon: "Favicon",
        backgroundLight: "Imagem de Fundo (Tema Claro)",
        backgroundDark: "Imagem de Fundo (Tema Escuro)",
        preview: "Visualizar",
        delete: "Excluir",
        upload: "Enviar",
        availableLanguages: "Idiomas Disponíveis",
        atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",
        inheritedHint: "Herdado do revendedor/plataforma até você alterar",
        termsUrl: "Link dos termos de uso",
        termsUrlHint: "Vazio = sem exigência de aceite",
        termsVersion: "Versão dos termos",
        termsVersionHint: "Mudar a versão exige novo aceite de todas as empresas",

        sections: {
          general: "Configurações Gerais",
          generalDescription: "Configure o nome e informações básicas da aplicação",
          colors: "Cores e Temas",
          colorsDescription: "Personalize as cores primárias para temas claro e escuro",
          logos: "Logos e Imagens",
          logosDescription: "Carregue os logos e imagens de fundo da aplicação",
          languages: "Idiomas Disponíveis",
          languagesDescription: "Selecione quais idiomas estarão disponíveis no sistema"
        }
      },
    },
  },
};

export { messages };
